import type { I18nKey } from "./es";

// Available immediately with the other UI dictionaries.
export const de: Record<I18nKey, string> = {
  "credits.extraShort": "+{count} zusätzlich",
  "credits.title": "Zusätzliche KI-Guthaben",
  "credits.offer": "100 KI-Aufrufe · 10 €",
  "credits.description": "Einmaliger Kauf für alle Nutzer. Das Guthaben verfällt nicht und wird nach den im Tarif enthaltenen Aufrufen verwendet.",
  "credits.unit": "Ein Guthabenpunkt ermöglicht die Extraktion einer Tagesdisposition (Callsheet). Fehlgeschlagene Versuche werden nicht abgezogen; eine erneute erfolgreiche Extraktion verbraucht einen weiteren Punkt.",
  "credits.balance": "Verfügbares Zusatzguthaben: {count}",
  "credits.balanceUnknown": "Das Guthaben wurde noch nicht überprüft.",
  "credits.buy": "100 Guthabenpunkte für 10 € kaufen",
  "credits.opening": "Zahlung wird geöffnet…",
  "credits.purchaseError": "Die Zahlung konnte nicht geöffnet werden. Bitte erneut versuchen.",
  "credits.confirmed": "Zahlung bestätigt: 100 Guthabenpunkte wurden hinzugefügt.",
  "credits.pending": "Die Zahlungsbestätigung steht noch aus. Wenn du bereits bezahlt hast, ist kein erneuter Kauf nötig.",
  "credits.checkPayment": "Zahlung prüfen",
  "credits.refunded": "Für diese Zahlung liegt eine Erstattung vor. Das Guthaben wurde aktualisiert.",
  "projects.showTrips": "Fahrten in {name} anzeigen",
  "projects.moveTripHint": "Ziehe eine Fahrt auf ein anderes Projekt oder wähle „Verschieben nach…“. Das Quellprojekt wird automatisch entfernt, wenn keine Fahrten, eigenständigen Dokumente oder Ausgaben verbleiben.",
  "projects.noTripsInFilter": "Keine Fahrten für diesen Filter.",
  "projects.dragTrip": "Fahrt vom {date} ziehen",
  "projects.moveTripLabel": "Fahrt vom {date} verschieben",
  "projects.moveTripTo": "Verschieben nach…",
  "projects.moveTripDone": "Fahrt nach „{name}“ verschoben.",
  "projects.moveTripRemoved": "Das Quellprojekt war leer und wurde entfernt.",
  "projects.moveTripRetained": "Das Quellprojekt enthält noch eigenständige Dokumente oder Ausgaben und bleibt erhalten.",
  "projects.moveTripFailed": "Die Verschiebung konnte nicht bestätigt werden. Aktualisiere die Liste vor einem erneuten Versuch.",
  "projects.moveTripUnavailable": "Zum Verschieben ist eine Datenbankaktualisierung erforderlich. Die Fahrt wurde nicht verschoben.",
  "bulk.retryLimit": "Du hast das Limit von 3 erneuten Versuchen erreicht. Prüfe und korrigiere das Dokument manuell.",
  "bulk.retryBusy": "Dieses Dokument wird bereits verarbeitet oder beide Verarbeitungsplätze sind belegt. Warte, bis eine Extraktion abgeschlossen ist, bevor du es erneut versuchst.",
  "bulk.retryDocument": "Extraktion erneut versuchen",
  "bulk.retryDocumentConfirm": "Extraktion von „{name}“ mit der bereits hochgeladenen Datei erneut starten? Eine erfolgreiche Extraktion wird auf dein Kontingent angerechnet.",
  "bulk.queueStartFailed": "Die Dateien sind gespeichert, aber der Warteschlangenstart konnte nicht bestätigt werden. Öffne dieses Fenster erneut, um fortzufahren.",
  "bulk.backgroundProcessing": "Du kannst dieses Fenster schließen: Hochgeladene Dokumente werden im Hintergrund weiterverarbeitet. Fehlgeschlagene Extraktionen werden nicht automatisch wiederholt.",
  "bulk.waitForUpload": "Warte, bis der Upload abgeschlossen und der Stapelstart bestätigt ist.",
  "bulk.deleteDocument": "Löschen",
  "bulk.deleteDocumentLabel": "Dokument {name} löschen",
  "bulk.deleteDocumentConfirm": "„{name}“ und die Originaldatei löschen? Dies kann nicht rückgängig gemacht werden.",
  "bulk.documentDeleted": "Dokument gelöscht.",
  "bulk.deleteDocumentError": "Das Dokument konnte nicht gelöscht werden. Es bleibt für einen erneuten Versuch verfügbar.",
  "plans.checking": "Abonnement wird geprüft…",
  "plans.unavailable": "Dein Abonnement konnte nicht geprüft werden. Versuche es erneut; du musst keinen weiteren Tarif kaufen.",
  "plans.statusUnavailable": "Abonnement nicht bestätigt",
  "ui.csvRows": "CSV: Spaltenüberschriften und mindestens eine Zeile sind erforderlich.",
  "ui.batchMax": "Maximal {count} Dokumente pro Stapel",
  "ui.uploaded": "{count} Dokumente hochgeladen",
  "ui.uploadedProcess": "{count} Dokumente hochgeladen. Zum Starten „Jetzt verarbeiten“ wählen.",
  "ui.uploadFailedCount": "{count} Dokumente konnten nicht hochgeladen werden",
  "ui.cancelledCount": "Verarbeitung abgebrochen ({count} Aufträge)",
  "ui.startingCount": "Extraktion von {count} Dokument(en) wird gestartet…",
  "ui.processedTrips": "Verarbeitete Fahrten ({count})",
  "ui.projectCreatedNamed": "Projekt „{name}“ erstellt",
  "ui.createdViaTrip": "Aus einer Fahrt erstellt",
  "ui.calendarImport": "Aus Google Calendar importiert",
  "ui.rowDate": "Zeile {row}: ungültiges Datum",
  "ui.rowProject": "Zeile {row}: Projektname fehlt",
  "ui.rowAddress": "Zeile {row}: Start/Ziel fehlen (und es ist keine Basisadresse festgelegt)",
  "ui.rowKm": "Zeile {row}: ungültige Kilometerzahl",
  "ui.rowStops": "Zeile {row}: zu viele Stopps",
  "ui.partialDelete": "{ok}/{total} gelöscht. {failed} fehlgeschlagen (zugehörige Daten konnten nicht vollständig gelöscht werden).",
  "ui.totalsUnavailable": "Die Projektsummen konnten nicht geladen werden. Bitte den Support kontaktieren.",
  "ui.projectExistsNamed": "Das Projekt „{name}“ existiert bereits",
  "ui.reportLimit": "Du hast das Berichtslimit deines Tarifs erreicht.",
  "ui.invalidTrip": "Ungültige Fahrtdaten. {issues}",
  "ui.profileSaving": "Wird gespeichert…",
  "ui.profileSaved": "Profil gespeichert",
  "ui.profileFailed": "Dein Profil konnte nicht gespeichert werden.",
  "ui.emptyFile": "{name}: Die Datei ist leer.",
  "ui.largeFile": "{name}: überschreitet das Dateilimit von 50 MB.",
  "ui.unclosedQuotes": "Eine Zelle enthält ein nicht geschlossenes Anführungszeichen. Prüfe den Text vor dem Speichern.",
  "ui.duplicateColumns": "Einige Spalten haben denselben Namen. Benenne sie vor dem Import um.",
  "ui.damagedOffice": "Das Office-Dokument ist beschädigt.",
  "ui.complexOffice": "Dieses Office-Dokument ist zu komplex. Teile es in mehrere Dateien auf.",
  "ui.expandedOffice": "Das Office-Dokument enthält zu viele entpackte Daten. Teile es in mehrere Dateien auf.",
  "ui.spreadsheetType": "{name}: Wähle CSV, TSV oder Excel (.xlsx, .xls).",
  "ui.invalidWorkbook": "{name}: keine gültige Excel-Arbeitsmappe.",
  "ui.noSheets": "{name}: Keine sichtbaren Tabellenblätter enthalten Daten.",
  "ui.invalidLogin": "E-Mail-Adresse oder Passwort falsch.",
  "ui.unexpected": "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
  "ui.googleConfiguration": "Die Verbindung zu Google ist fehlgeschlagen. Versuche es erneut oder kontaktiere den Support.",
  "ui.security": "Sicherheit",
  "ui.passwordHint": "Lege ein Passwort fest oder ändere es, um dich mit deiner E-Mail-Adresse anzumelden.",
  "ui.changePassword": "Passwort ändern",
  "ui.geminiDefault": "Gemini-KI (Standard)",
  "ui.model": "OpenRouter-Modell",
  "ui.selectModel": "Modell auswählen",
  "ui.loadingModels": "Modelle werden geladen…",
  "ui.visionModels": "Diese Modelle unterstützen die Erkennung von Bildern und PDFs.",
  "ui.lastExtraction": "Letzte KI-Extraktion",
  "ui.checkingProvider": "Verwendeter Anbieter wird geprüft…",
  "ui.provider": "Anbieter:",
  "ui.modelLabel": "Modell:",
  "ui.actualProvider": "Tatsächlicher Anbieter:",
  "ui.date": "Datum:",
  "ui.noExtraction": "Es wurde noch keine Extraktion mit Anbieterangaben gespeichert.",
  "ui.disconnect": "Verbindung trennen",
  "ui.changelog": "Änderungsprotokoll",
  "ui.noUpdates": "Es ist noch kein Aktualisierungskanal eingerichtet.",
  "ui.noChangelog": "Das Änderungsprotokoll ist in der App noch nicht verfügbar.",
  "ui.noSupport": "Der Supportkanal ist noch nicht eingerichtet.",
  "ui.uploadCallsheet": "Callsheet hochladen",
  "ui.deleteCallsheet": "Dieses Callsheet löschen? Die zugehörigen Daten werden ebenfalls gelöscht.",
  "ui.alreadyProcessing": "Dieses Dokument wird bereits verarbeitet",
  "ui.reprocess": "Dieses Dokument wurde bereits verarbeitet. Erneut verarbeiten? Dadurch wird eine weitere Extraktion von deinem Kontingent abgezogen.",
  "ui.quotaPreserved": "Kein Kontingent mehr verfügbar. Das Dokument und die bisherigen Ergebnisse bleiben erhalten.",
  "ui.quotaUnavailable": "Dein Kontingent konnte nicht geprüft werden. Das Dokument bleibt erhalten; versuche es später erneut.",
  "ui.processingCancelled": "Verarbeitung abgebrochen; Dokument bleibt erhalten",
  "ui.noPendingDocuments": "Es warten keine Dokumente auf die Verarbeitung",
  "ui.reviewProcessed": "Prüfe die automatisch extrahierten Fahrten und speichere sie gemeinsam",
  "ui.processAI": "Mit KI verarbeiten",
  "ui.producerExample": "z. B. Filmproduktion XY",
  "ui.loading": "Wird geladen…",
  "ui.templateExample": "z. B. Besuch bei Kunde X",
  "ui.routeRequired": "Die Route benötigt einen Start- und einen Zielort",
  "ui.templateFailed": "Vorlage konnte nicht gespeichert werden",
  "ui.dateRequired": "Datum auswählen",
  "ui.fillRoute": "Start- und Zielort eingeben",
  "ui.commands": "Befehle",
  "ui.commandHint": "Befehle suchen und ausführen",
  "ui.noRecentTrips": "Keine aktuellen Fahrten.",
  "ui.offline": "Du bist offline. Gespeicherte Daten können angezeigt werden, Änderungen werden aber erst wieder mit Internetverbindung synchronisiert.",
  "ui.captchaFailed": "Die Sicherheitsprüfung konnte nicht abgeschlossen werden. Prüfe deine Verbindung.",
  "ui.retry": "Erneut versuchen",
  "ui.emissionsLoading": "Emissionsdaten werden geladen…",
  "ui.maxStops": "Maximal 8 Zwischenstopps",
  "ui.templateRouteRequired": "Die Vorlage benötigt einen Start- und einen Zielort",
  "ui.deleteStop": "Stopp entfernen",
  "ui.projectDeleteFailed": "Das Projekt konnte nicht gelöscht werden.",
  "ui.projectExists": "Ein Projekt mit diesem Namen ist bereits vorhanden",
  "ui.projectUpdated": "Projekt aktualisiert",
  "ui.projectCreated": "Projekt erstellt",
  "ui.tripDeleteFailed": "Die Fahrt konnte nicht gelöscht werden.",
  "ui.tripUpdateFailed": "Die Fahrt konnte nicht aktualisiert werden. Die vorherige Version bleibt erhalten.",
  "ui.distance": "Entfernung:",
  "ui.eventTitleRequired": "Gib einen Titel für den Termin ein",
  "ui.eventDates": "Prüfe Datum und Uhrzeit von Beginn und Ende",
  "ui.eventEnd": "Die Endzeit muss nach der Startzeit liegen",
  "ui.eventCreated": "Termin erstellt",
  "ui.enterEmail": "E-Mail-Adresse eingeben",
  "ui.recoveryEmailHint": "Gib oben deine E-Mail-Adresse ein, damit wir dir einen Wiederherstellungslink senden können.",
  "ui.emailSent": "E-Mail gesendet",
  "ui.checkInbox": "Prüfe deinen Posteingang, um dein Passwort zurückzusetzen.",
  "ui.sendFailed": "Senden fehlgeschlagen",
  "ui.googleFailed": "Anmeldung mit Google fehlgeschlagen",
  "ui.passwordUpdated": "Passwort aktualisiert",
  "ui.newPasswordLogin": "Du kannst dich jetzt mit deinem neuen Passwort anmelden.",
  "ui.authError": "Authentifizierungsfehler",
  "ui.noGoogleResponse": "Keine Antwort von Google erhalten",
  "ui.retryLogin": "Versuche es erneut auf der Anmeldeseite.",
  "ui.loginFailed": "Die Anmeldung konnte nicht abgeschlossen werden",
  "ui.checkGoogleSetup": "Prüfe die Google-Konfiguration in Supabase.",
  "ui.invalidSession": "Ungültige Sitzung",
  "ui.sessionFailed": "Die Sitzung konnte nach der Anmeldung nicht wiederhergestellt werden.",
  "ui.verifyingAuth": "Anmeldung wird überprüft…",
  "ui.invalidLink": "Ungültiger Link",
  "ui.newRecoveryEmail": "Fordere eine neue E-Mail zum Zurücksetzen deines Passworts an.",
  "ui.backLogin": "Zurück zur Anmeldung",
  "ui.backLogin2": "Zurück zur Anmeldung",
  "ui.secureReset": "Sicheres Zurücksetzen des Passworts",
  "ui.confirmReset": "Bestätige, dass du fortfahren möchtest, um ein neues Passwort für Fahrtenbuch Pro zu erstellen.",
  "ui.anotherLink": "Neuen Link anfordern",
  "ui.continueSecure": "Sicher fortfahren",
  "ui.verificationSlow": "Die Überprüfung dauert zu lange. Prüfe deine Verbindung und versuche es erneut.",
  "ui.expiredLink": "Dieser Link ist abgelaufen oder wurde bereits verwendet. Fordere eine neue Wiederherstellungs-E-Mail an.",
  "ui.verifyLinkFailed": "Der Link konnte nicht überprüft werden. Fordere eine neue Wiederherstellungs-E-Mail an.",
  "ui.supabaseMissing": "Supabase ist nicht eingerichtet",
  "ui.supabaseEnvMissing": "Supabase-Umgebungsvariablen fehlen.",
  "ui.sessionMissing": "Sitzung nicht gefunden",
  "ui.openRecoveryEmail": "Öffne den Wiederherstellungslink in deiner E-Mail.",
  "ui.passwordMismatch": "Die Passwörter stimmen nicht überein",
  "ui.passwordShort": "Das Passwort ist zu kurz",
  "ui.passwordMin": "Verwende mindestens 8 Zeichen.",
  "ui.passwordEmailLogin": "Du kannst dich jetzt mit E-Mail-Adresse und Passwort anmelden.",
  "ui.updateFailed": "Aktualisierung fehlgeschlagen",
  "ui.checkCurrentPassword": "Prüfe dein aktuelles Passwort und versuche es erneut.",
  "ui.unexpectedError": "Unerwarteter Fehler",
  "ui.resetPassword": "Passwort zurücksetzen",
  "ui.recoverySessionHint": "Öffne den Wiederherstellungslink aus unserer E-Mail. Falls du ihn bereits geöffnet hast, aber hier keine Sitzung besteht, versuche es erneut.",
  "ui.verificationNeeded": "Überprüfung erforderlich",
  "ui.startSecureChange": "Starte die Änderung in den Einstellungen oder verwende den sicheren Link aus deiner E-Mail.",
  "ui.backDashboard": "Zurück zur Übersicht",
  "ui.secureLinkSent": "Sicherer Link gesendet",
  "ui.openSecureEmail": "Öffne die E-Mail, um sicher ein Passwort festzulegen.",
  "ui.linkSendFailed": "Der Link konnte nicht gesendet werden",
  "ui.retryLater": "Warte einige Minuten und versuche es erneut.",
  "ui.setPassword": "Passwort festlegen",
  "ui.externalAccount": "Dein Konto verwendet einen externen Anbieter. Zu deinem Schutz senden wir einen einmaligen Link an deine bestätigte E-Mail-Adresse.",
  "ui.sendSecureLink": "Sicheren Link senden",
  "ui.newPassword": "Neues Passwort",
  "ui.choosePassword": "Wähle ein neues Passwort für dein Konto.",
  "ui.currentPassword": "Aktuelles Passwort",
  "ui.password": "Passwort",
  "ui.confirmPassword": "Passwort bestätigen",
  "ui.save": "Speichern",
  "ui.errorTitle": "Etwas ist schiefgelaufen",
  "ui.errorBody": "In der App ist ein unerwarteter Fehler aufgetreten. Lade sie neu oder versuche es erneut.",
  "ui.reload": "Neu laden",
  "ui.errorSupport": "Wenn das Problem weiterhin besteht, prüfe deine Verbindung oder kontaktiere den Support.",
  "ui.reloadConfirm": "Dieser Tab wird neu geladen. Nicht gespeicherte Änderungen gehen verloren. Fortfahren?",
  "ui.callsheetUploadFailed": "Callsheet konnte nicht hochgeladen werden",
  "ui.home": "Startseite",

  "modal.close": "Schließen",
  "modal.addDocuments": "Dokumente hinzufügen",
  "modal.addExpense": "Ausgabe hinzufügen",
  "modal.details": "Fahrtdaten",
  "modal.noTrips": "Dieses Projekt hat noch keine Fahrten.",
  "modal.options": "Fahrtoptionen",
  "modal.uploadHelp": "Formate und Limits",
  "modal.select": "Auswählen",
  "modal.process": "Verarbeiten",
  "modal.review": "Prüfen",
  "modal.files": "Dateien",
  "modal.text": "Text einfügen",
  "modal.vehicle": "Fahrzeug",
  "modal.costs": "Tarife und Kosten",
  "modal.security": "Sicherheit",
  "modal.integrations": "Integrationen",
  "modal.summary": "Übersicht",
  "modal.documents": "Dokumente",
  "modal.calculate": "Entfernung berechnen",
  "modal.uploadLimit": "Bis zu {count} Dateien · 50 MB pro Datei",
  "modal.batchReview": "Öffne ein Dokument, um Daten und Route zu prüfen.",
  "callsheetReview.deletePartial": "{deleted} Einträge gelöscht. {failed} konnten nicht gelöscht werden und bleiben für einen erneuten Versuch ausgewählt.",
  "tripDetail.editInvalid": "Prüfe das Datum, ergänze alle Adressen und gib gültige Entfernungen und Beträge ein.",
  "tripDetail.editInvalidDocument": "Prüfe das Datum und behalte mindestens einen gültigen Drehort. Ergänze oder entferne leere Drehorte. Kilometer, Mitfahrer und Ausgaben sind optional; eingegebene Werte müssen gültig sein.",
  "callsheetReview.title": "Prüfen",
  "callsheetReview.description": "Extrahierte Daten zur Bestätigung.",
  "callsheetReview.detectedDate": "Erkanntes Datum",
  "callsheetReview.incompleteDate": "Datum ergänzen oder bestätigen",
  "callsheetReview.checkData": "Erkannte Daten prüfen",
  "callsheetReview.details": "Details anzeigen",
  "callsheetReview.open": "Dokument ansehen",
  "callsheetReview.edit": "Fahrt ergänzen",
  "callsheetReview.loadError": "Die zu prüfenden Dokumente konnten nicht geladen werden. Bitte erneut versuchen.",
  "callsheetReview.retry": "Erneut versuchen",

  "updates.available": "Neue Version verfügbar",
  "updates.description": "Aktualisiere, nachdem du deine Arbeit gespeichert hast. Andere Tabs bleiben geöffnet.",
  "updates.action": "Aktualisieren",
  "updates.closeEditor": "Speichere oder schließe das offene Formular vor dem Aktualisieren.",
  "updates.confirm": "Dieser Tab wird neu geladen. Ungespeicherte Änderungen gehen verloren. Fortfahren?",
  "updates.failed": "Das Update konnte nicht aktiviert werden. Dein Tab bleibt geöffnet; versuche es erneut.",
  "expenseScan.deleteConfirm": "Dieser Beleg wird endgültig gelöscht",
  "expenseScan.deleteRecoveryError": "Das Löschen konnte nicht abgeschlossen und die Belegverknüpfung nicht wiederhergestellt werden. Die Löschung wurde nicht bestätigt. Lade die Fahrt oder das Projekt neu und kontaktiere den Support, falls der Beleg weiterhin fehlt.",
  "uploads.invalidNameTitle": "Ungültiger Dateiname",
  "uploads.invalidNameBody": "„{name}“ enthält Ordnertrennzeichen oder Steuerzeichen. Wähle eine Datei mit gültigem Namen aus.",
  "uploads.fileNameHint": "Originalnamen mit #, Umlauten und Leerzeichen können beibehalten werden.",
  "uploads.ownershipError": "Es konnte nicht bestätigt werden, dass diese Datei deinem Konto gehört. Prüfe ihren Namen und lade sie angemeldet erneut hoch. Falls der Fehler erneut auftritt, kontaktiere den Support.",
  "uploads.callsheetFormats": "PDF, JPG/JPEG, PNG, WebP, HEIC/HEIF, Excel (XLSX/XLS), CSV, TSV, TXT und Word (DOCX).",
  "uploads.callsheetLimits": "Bis zu {count} Dateien pro Stapel und 50 MB pro Datei. Der KI-Anbieter kann Seiten-, Inhalts- oder Zeitlimits anwenden.",
  "bulk.manualReview": "Zeilen vor dem Speichern prüfen und bearbeiten. Fehlende Kilometer werden als 0 gespeichert und können unter Fahrten korrigiert werden.",
  "bulk.removeFile": "Datei entfernen",
  "bulk.removeRow": "Zeile entfernen",
  "bulk.rows": "Zeilen",
  "bulk.manualDuplicates": "{count} doppelte oder bereits gespeicherte Fahrten übersprungen.",
  "bulk.manualDropHint": "CSV oder Excel hier ablegen oder zum Auswählen klicken. Bis zu 50 MB pro Datei.",
  "bulk.saveManual": "Geprüfte Fahrten speichern",
  "bulk.reviewPastedCsv": "Eingefügtes CSV prüfen",
  "bulk.aiPasteLabel": "Text einer E-Mail oder Nachricht",
  "bulk.aiPasteHint": "Den auszuwertenden Inhalt hier einfügen…",
  "bulk.aiAddText": "Text zur Liste hinzufügen",
  "bulk.aiTextQuotaHint": "Jeder hinzugefügte Text zählt als ein Dokument. Das Kontingent wird bei der KI-Verarbeitung verbraucht.",
  "uploads.callsheetConversion": "Für E-Mails und Nachrichten den Text im KI-Tab einfügen. Kein Download als E-Mail-Datei nötig.",
  "bulk.csvExcelHint": "CSV, TSV und Excel (.xlsx, .xls). Sichtbare Tabellenblätter werden gelesen; vor dem Speichern prüfen. Kein KI-Verbrauch.",
  "expenseScan.fileHint": "Bilder bis zu 10 MB, einzeln auswählen. Du kannst mehrere Belege zu derselben Ausgabe hinzufügen. Dieser Scanner akzeptiert keine PDFs.",
  "nav.dashboard": "Übersicht",
  "nav.trips": "Fahrten",
  "nav.projects": "Projekte",
  "nav.reports": "Berichte",
  "nav.calendar": "Kalender",
  "nav.advanced": "Erweitert",
  "nav.settings": "Einstellungen",
  "nav.menu": "Menü",
  "nav.expand": "Erweitern",
  "nav.collapse": "Reduzieren",

  "nav.logout": "Abmelden",
  "dashboard.welcomeBack": "Willkommen zurück, {name}",
  "dashboard.welcomeBackPrefix": "Hallo,",
  "dashboard.greetingMorning": "Guten Morgen,",
  "dashboard.greetingAfternoon": "Guten Tag,",
  "dashboard.greetingEvening": "Guten Abend,",
  "dashboard.subtitle": "Hier ist deine Kilometerübersicht für diesen Monat",
  "dashboard.totalDistance": "Gesamtdistanz",
  "dashboard.activeProjects": "Aktive Projekte",
  "dashboard.co2Emissions": "CO₂-Emissionen",
  "dashboard.thisMonthVsPrevious": "dieser Monat vs. vorheriger",
  "dashboard.vsLastMonth": "vs letzten Monat",
  "dashboard.viewTrips": "Fahrten ansehen",
  "dashboard.viewProjects": "Projekte ansehen",
  "dashboard.viewCo2": "CO₂ ansehen",
  "dashboard.thisMonth": "Diesen Monat",
  "dashboard.lastMonth": "Letzter Monat",
  "dashboard.trend": "Tendenz",
  "dashboard.totalKm": "Gesamt km",
  "dashboard.status": "Status",
  "dashboard.equivalentTrees": "Äquivalente Bäume",
  "dashboard.equivalentTreesTooltip": "Anschaulicher Vergleich: etwa 21 kg CO₂ pro ausgewachsenem Baum in einem Jahr. Abhängig von Art und Bedingungen; keine tatsächliche CO₂-Kompensation.",
  "dashboard.excellent": "Ausgezeichnet",
  "dashboard.good": "Gut",
  "dashboard.improvable": "Verbesserungsfähig",
  "dashboard.warnings": "Warnungen",
  "dashboard.noWarnings": "Keine Warnungen",
  "tripWarning.invalidDate": "Ungültiges Datum",
  "tripWarning.noDate": "Kein Datum",
  "tripWarning.incompleteRoute": "Unvollständige Route",
  "tripWarning.missingOriginDestination": "Herkunft/Ziel fehlt",
  "tripWarning.zeroDistance": "Entfernung 0 km",
  "tripWarning.noDistance": "Keine Entfernung",
  "tripWarning.improbableDistance": "Unwahrscheinliche Entfernung",
  "tripWarning.noProject": "Kein Projekt",
  "tripWarning.assignProject": "Projekt zuweisen zum Gruppieren und Berichten",
  "tripWarning.duplicateTrip": "Doppelte Fahrt",
  "tripWarning.sameDateAndRoute": "Gleiches Datum und Route",
  "trips.title": "Fahrten",
  "trips.subtitle": "Alle Dienstfahrten verwalten und verfolgen",
  "trips.delete": "Löschen",
  "trips.bulkUpload": "Massenimport",
  "trips.addTrip": "Fahrt hinzufügen",
  "trips.project": "Projekt",
  "trips.allProjects": "Alle Projekte",
  "trips.all": "Alle",
  "trips.year": "Jahr",
  "trips.date": "Datum",
  "trips.route": "Route",
  "trips.co2": "CO₂",
  "trips.passengers": "Mitfahrer",
  "trips.reimbursement": "Erstattung",
  "trips.expenses": "Ausgaben",
  "trips.receipts": "Belege",
  "trips.totalCost": "Gesamtkosten",
  "trips.distance": "Distanz",
  "trips.viewMap": "Karte ansehen",
  "trips.addToCalendar": "Zum Kalender hinzufügen",
  "trips.edit": "Bearbeiten",
  "trips.showing": "{count} Fahrten angezeigt",
  "trips.of": "von",
  "trips.loadMore": "Mehr laden",
  "trips.total": "Summe: {km} km",
  "trips.sortByDate": "Nach Datum sortieren ({order})",
  "trips.sortAsc": "aufsteigend",
  "trips.sortDesc": "absteigend",
  "trips.toastAddedToCalendarTitle": "Zum Kalender hinzugefügt",
  "trips.toastAddedToCalendarBody": "Fahrt nach {destination} am {date} zum Kalender hinzugefügt.",
  "trips.toastTripsDeletedTitle": "Fahrten gelöscht",
  "trips.toastTripsDeletedBody": "{count} Fahrt(en) gelöscht.",
  "trips.toastTripCreatedTitle": "Fahrt gespeichert",
  "trips.toastTripCreatedBody": "Die Fahrt wurde erfolgreich gespeichert.",
  "trips.continuation": "Fortsetzung",
  "trips.returnTrip": "Rückfahrt",
  "trips.toastTripUpdatedTitle": "Fahrt aktualisiert",
  "trips.toastTripUpdatedBody": "Änderungen wurden erfolgreich gespeichert.",
  "trips.calendarNotConnected": "Google Kalender ist nicht verbunden. Verbinde ihn in Einstellungen > APIs.",
  "trips.selectTrip": "Fahrt auswählen {id}",
  "projects.title": "Projekte",
  "projects.subtitle": "Fahrten nach Projekt organisieren für einfache Berichte",
  "projects.delete": "Löschen",
  "projects.newProject": "Neues Projekt",
  "projects.createNewProject": "Neues Projekt erstellen",
  "projects.projectName": "Projektname",
  "projects.company": "Firma / Kunde",
  "projects.companyPlaceholder": "Firmenname",
  "projects.description": "Beschreibung",
  "projects.descriptionPlaceholder": "Kurze Projektbeschreibung",
  "projects.ratePerKm": "Satz pro km (€)",
  "projects.ratePerPassenger": "Satz pro Mitfahrer (€)",
  "projects.createProject": "Projekt erstellen",
  "projects.filterProducer": "Produktionsfirma",
  "projects.searchPlaceholder": "Projekte suchen...",
  "projects.year": "Jahr",
  "projects.allTime": "Gesamte Zeit",
  "projects.selectAll": "Alle auswählen",
  "projects.tableDate": "Datum",
  "projects.tableProject": "Projekt",
  "projects.tableCompany": "Firma / Kunde",
  "projects.tableTrips": "Fahrten",
  "projects.tableTotalKm": "Gesamtdistanz",
  "projects.tableCo2": "CO₂ (kg)",
  "projects.tableDocuments": "Dokumente / Callsheets",
  "projects.tableInvoices": "Rechnungen",
  "projects.tableCost": "Erstattung",
  "projects.viewDetails": "Details ansehen",
  "projects.edit": "Bearbeiten",
  "projects.emptyTitle": "Keine Projekte gefunden",
  "projects.emptyTryAdjust": "Suche anpassen",
  "projects.emptyCreateFirst": "Erstelle dein erstes Projekt, um zu starten",
  "projects.summaryCount": "{count} Projekte",
  "projects.summaryTotal": "Summe: {km} km",
  "projects.toastDeletedTitle": "Projekte gelöscht",
  "projects.toastDeletedBody": "{count} Projekt(e) gelöscht.",
  "projects.selectProject": "Projekt auswählen {name}",
  "tripModal.addTitle": "Fahrt hinzufügen",
  "tripModal.editTitle": "Fahrt bearbeiten",
  "tripModal.date": "Datum",
  "tripModal.project": "Projekt",
  "tripModal.selectProject": "Projekt auswählen",
  "tripModal.route": "Route",
  "tripModal.addStop": "Stopp hinzufügen",
  "tripModal.specialOrigin": "Spezial-Ursprung",
  "tripModal.specialOriginBase": "Start von meiner Basisadresse",
  "tripModal.specialOriginContinue": "Vom letzten Ziel fortsetzen",
  "tripModal.specialOriginReturn": "Zur Basisadresse zurück (vom letzten Ziel)",
  "tripModal.passengers": "Mitfahrer",
  "tripModal.fuelLiters": "Kraftstoff (L)",
  "tripModal.evKwhUsed": "Stromverbrauch (kWh)",
  "tripModal.distance": "Distanz (km)",
  "tripModal.rate": "Fahrtsatz (€/km)",
  "tripModal.purpose": "Zweck",
  "tripModal.purposePlaceholder": "Fahrzweck",
  "tripModal.toll": "Maut (€)",
  "tripModal.parking": "Parken (€)",
  "tripModal.otherExpenses": "Sonstiges (€)",
  "tripModal.fuel": "Kraftstoff (€)",
  "tripModal.save": "Fahrt speichern",
  "tripModal.update": "Fahrt aktualisieren",
  "tripModal.origin": "Start",
  "tripModal.destination": "Ziel",
  "tripModal.stop": "Stopp",
  "tripModal.originPlaceholder": "Startort",
  "tripModal.destinationPlaceholder": "Zielort",
  "tripModal.stopPlaceholder": "Zwischenstopp",
  "tripModal.projectSearchPlaceholder": "Projekt suchen oder erstellen...",
  "tripModal.projectNotFound": "Nicht gefunden.",
  "tripModal.createProjectNamed": "Projekt \"{name}\" erstellen",
  "tripModal.useAsClient": "\"{name}\" als Kunden verwenden",
  "calendar.title": "Kalender",
  "calendar.subtitle": "Ereignisse aus Google Calendar synchronisieren",
  "calendar.refresh": "Aktualisieren",
  "calendar.connectGoogle": "Google verbinden",
  "calendar.calendars": "Kalender",
  "calendar.notConnected": "Nicht verbunden",
  "calendar.notConnectedBody": "Verbinde deinen Google Calendar, um Ereignisse zu synchronisieren und Fahrten daraus zu erstellen.",
  "calendar.connect": "Verbinden",
  "calendar.disconnect": "Trennen",
  "calendar.insufficientPermissionsTitle": "Unzureichende Berechtigungen",
  "calendar.insufficientPermissionsBody": "Google-Calendar-Berechtigungen müssen aktualisiert werden, um deine Kalender zu listen. Trenne die Verbindung und verbinde erneut.",
  "calendar.reconnect": "Erneut verbinden",
  "calendar.createEventTitle": "Termin erstellen",
  "calendar.eventTitleLabel": "Titel",
  "calendar.eventTitlePlaceholder": "Meeting / Fahrt / Erinnerung",
  "calendar.calendarLabel": "Kalender",
  "calendar.selectCalendarPlaceholder": "Kalender auswählen",
  "calendar.startLabel": "Beginn",
  "calendar.endLabel": "Ende",
  "calendar.cancel": "Abbrechen",
  "calendar.creating": "Wird erstellt...",
  "calendar.create": "Erstellen",
  "calendar.loading": "Lädt...",
  "calendar.more": "+{count} mehr",
  "calendar.weekdays": "Mo,Di,Mi,Do,Fr,Sa,So",
  "calendar.importEventTitle": "Termin als Fahrt importieren",
  "calendar.importEventDescription": "Eine Fahrt basierend auf diesem Kalenderereignis erstellen",
  "calendar.eventLocation": "Ort",
  "calendar.eventDescription": "Beschreibung",
  "calendar.importWillCreate": "Erstellt eine Fahrt mit:",
  "calendar.importClientFromTitle": "Kunde/Unternehmen: Termintitel",
  "calendar.importRouteFromBase": "Route: von Basisadresse (Hin- und Rückfahrt)",
  "calendar.importProjectManual": "Projekt: auf 'Unknown' gesetzt (später bearbeitbar)",
  "calendar.importDistanceCalculated": "Entfernung: automatisch berechnet",
  "calendar.viewInGoogle": "In Google ansehen",
  "calendar.importAsTrip": "Als Fahrt importieren",
  "calendar.importing": "Wird importiert...",
  "calendar.importSuccess": "Fahrt erfolgreich importiert",
  "calendar.importError": "Termin konnte nicht importiert werden",
  "calendar.importNoLocations": "Keine Orte im Termin gefunden. Füge einen Ort oder eine Beschreibung mit Ursprung und Ziel hinzu.",
  "calendar.importNoDistance": "Entfernung konnte nicht berechnet werden. Überprüfe die Orte.",
  "calendar.importNeedBaseAddress": "Ergänze deine Basisadresse, Stadt und dein Land in den Einstellungen, bevor du das Ereignis importierst.",

  // Advanced
  "advanced.title": "Erweitert",
  "advanced.subtitle": "Erweiterte Tools und Analysen",
  "advanced.routesTitle": "Routenvorlagen",
  "advanced.routesBody": "Verwalte häufige Routen und vordefinierte Vorlagen",
  "advanced.costsTitle": "Kostenanalyse",
  "advanced.costsBody": "Analysiere Ausgaben, Kraftstoff und Wartung",
  "advanced.emissionsTitle": "CO₂-Emissionen",
  "advanced.emissionsBody": "CO₂-Fußabdruck und Effizienz verfolgen",
  "auth.tagline": "Professionelles Kilometer-Tracking",
  "auth.featureTrips": "🚗 Jede Fahrt erfassen",
  "auth.featureTripsBody": "Distanzen automatisch per GPS oder KI-Extraktion aus Callsheets erfassen.",
  "auth.featureReports": "📊 Berichte erstellen",
  "auth.featureReportsBody": "Berichte erstellen, bereit zum Download und Druck.",
  "auth.featureImport": "🤖 KI-Import",
  "auth.featureImportBody": "Fahrtdaten automatisch aus PDFs, Bildern und Callsheets extrahieren.",
  "auth.login": "Anmelden",
  "auth.signUp": "Registrieren",
  "auth.pleaseSignIn": "Bitte anmelden",
  "auth.fullName": "Vollständiger Name",
  "auth.password": "Passwort",
  "auth.forgotPassword": "Passwort vergessen?",
  "auth.createAccount": "Konto erstellen",
  "auth.verifyEmailTitle": "E-Mail bestätigen",
  "auth.verifyEmailBody": "Wir haben dir eine E-Mail zur Bestätigung gesendet. Prüfe Posteingang (und Spam).",
  "auth.orContinueWith": "Oder fortfahren mit",
  "auth.continueWithGoogle": "Mit Google fortfahren",
  "auth.byContinuing": "Durch Fortfahren stimmst du unseren",
  "auth.and": "und",
  "auth.terms": "Nutzungsbedingungen",
  "auth.privacy": "Datenschutzrichtlinie",
  "auth.heroTitle": "Dein Kilometergeld, auf Autopilot.",
  "auth.heroBullet1": "Lade das Callsheet des Drehtags hoch",
  "auth.heroBullet2": "Die KI erstellt die Fahrten mit Route und km",
  "auth.heroBullet3": "Monatlicher PDF-Bericht für die Produktion",
  "auth.heroFooter": "Film- und TV-Crew in Österreich · Drehs in DE, CZ und HU",
  "auth.heroCardTitle": "Kilometergeld-Abrechnung",
  "auth.heroCardMeta": "Juni 2026 · 26 Fahrten · 3 Belege",
  "auth.heroCardTotalLabel": "GESAMT JUNI",
  "auth.welcomeBackTitle": "Anmelden",
  "auth.welcomeBackSubtitle": "Greife auf dein bestehendes Konto zu.",
  "auth.createAccountTitle": "Konto erstellen",
  "auth.createAccountSubtitle": "Kostenlos starten. Ohne Kreditkarte.",
  "auth.googleAccountNotFoundTitle": "Dieses Konto existiert noch nicht",
  "auth.googleAccountNotFoundBody": "Wähle zum Registrieren „Kostenlos starten“ und fahre mit Google fort.",
  "auth.googleAccountCheckFailed": "Das Google-Konto konnte nicht geprüft werden. Bitte versuche es erneut.",
  "auth.orWithEmail": "oder mit deiner E-Mail",
  "auth.noAccount": "Noch kein Konto?",
  "auth.startFree": "Kostenlos starten",
  "auth.haveAccount": "Schon ein Konto?",
  "auth.email": "E-Mail",
  "auth.emailPlaceholder": "du@email.com",
  "auth.showPassword": "Passwort anzeigen",
  "auth.hidePassword": "Passwort verbergen",
  "notFound.message": "Ups! Seite nicht gefunden",
  "common.allCompanies": "Alle Firmen",
  "common.comingSoon": "Kommt bald",
  "notFound.returnHome": "Zur Startseite",
  "chart.kmByProject": "Kilometer nach Projekt",
  "chart.kmByWeek": "Kilometer pro Woche",
  "chart.kmByMonth": "Kilometer pro Monat",
  "chart.kmByYear": "Kilometer pro Jahr",
  "chart.distance": "Distanz",
  "chart.filterProject": "Projekt",
  "chart.filterAll": "Alle",
  "chart.filterWeek": "Woche",
  "chart.filterMonth": "Monat",
  "chart.filterYear": "Jahr",
  "chart.filterAllProjects": "Alle",
  "chart.noData": "Keine Daten vorhanden",
  "dashboard.recentTrips": "Letzte Fahrten",
  "dashboard.viewAll": "Alle ansehen",
  "bulk.aiExtraction": "KI-Extraktion",
  "bulk.title": "Assistent für Massenimport",
  "bulk.subtitle": "Fahrten aus CSV oder Excel importieren oder Dokumente und Nachrichten mit KI auswerten.",
  "bulk.tabCsv": "CSV / Excel · Manuell",
  "bulk.tabAi": "KI-Extraktion",
  "bulk.csvInstructionsTitle": "Hinweise zum CSV-Import",
  "bulk.csvInstructionsRequired": "Erforderliche Spalten: 'date', 'projectName', 'origin', 'destination'. Optional: 'reason', 'distance' und 'client'/'company'/'producer'.",
  "bulk.csvInstructionsStops": "Spalten zwischen 'origin' und 'destination' (in der Reihenfolge der CSV) werden als Zwischenstopps behandelt. Spalten 'client'/'company'/'producer' werden als Projekt-Metadaten behandelt. Wenn 'origin' oder 'destination' leer sind, wird deine Basisadresse verwendet.",
  "bulk.csvInstructionsSeparator": "Die Datei kann durch Komma (,) oder Semikolon (;) getrennt sein. Der Import erkennt dies automatisch.",
  "bulk.selectCsvFile": "CSV oder Excel auswählen",
  "bulk.importFromDrive": "Aus Google Drive importieren",
  "bulk.drivePickerTitle": "CSV in Google Drive auswaehlen",
  "bulk.drivePickerTitlePdf": "PDFs in Google Drive auswaehlen",
  "bulk.drivePickerTitleCallsheets": "Callsheets in Google Drive auswaehlen (PDF oder Bild)",
  "bulk.downloadingFromDrive": "Von Drive herunterladen...",
  "bulk.importPdfFromDrive": "PDFs von Google Drive importieren",
  "bulk.errorDrivePickerNotConfigured": "VITE_GOOGLE_PICKER_API_KEY fehlt, um den Google Drive Picker zu oeffnen.",
  "bulk.or": "oder",
  "bulk.pasteCsv": "CSV-Text einfügen",
  "bulk.processPasted": "Eingefügten Text verarbeiten",
  "bulk.cancel": "Abbrechen",
  "bulk.toastProcessingCancelled": "Die Extraktion wurde beim Schliessen des Modals abgebrochen.",
  "bulk.aiCancelExtraction": "Extraktion abbrechen",
  "bulk.toastBackgroundProcessing": "Die Extraktion läuft im Hintergrund weiter. Öffne den Assistenten erneut, um sie zu prüfen.",
  "bulk.aiDropTitle": "Dokumente hier ablegen",
  "bulk.aiDropSubtitle": "Callsheets als PDF oder Bilder (JPG/JPEG, PNG, WebP, HEIC und HEIF)",
  "bulk.aiChangeFilesHint": "Klicken oder weitere Dateien hier ablegen.",
  "bulk.aiFilesSelected": "{count} Dateien ausgewählt",
  "bulk.aiDescription": "Lade deine Callsheets als PDF oder Foto hoch. Die KI extrahiert automatisch Datum, Orte, Projekt und Distanzen.",
  "bulk.aiDisclaimer": "KI kann Fehler machen. Der Benutzer ist dafür verantwortlich, dass die extrahierten Informationen vor dem Speichern korrekt sind.",
  "bulk.aiProcessingTitle": "Dokumente werden analysiert...",
  "bulk.aiProcessingHint": "Das kann ein paar Sekunden dauern.",
  "bulk.aiProcessingProgress": "Abgeschlossen {done}/{total} | Ausstehend {pending} | Fehlgeschlagen {failed}",
  "bulk.aiParallelReviewTitle": "Dokumente prüfen",
  "bulk.aiParallelReviewStats": "Bereit {ready} · Zu prüfen {review} · Gespeichert {saved} · Ausstehend {pending} · Fehlgeschlagen {failed} · Abgebrochen {cancelled}",
  "bulk.back": "Zurück",
  "bulk.saveAll": "Alle speichern",
  "bulk.statusSaved": "Gespeichert",
  "bulk.statusReady": "Fertig",
  "bulk.statusProcessing": "In Bearbeitung",
  "bulk.statusQueued": "In Warteschlange",
  "bulk.statusFailed": "Fehlgeschlagen",
  "bulk.statusNeedsReview": "Prüfen",
  "bulk.statusOutOfQuota": "Limit erreicht",
  "bulk.statusProcessingEllipsis": "In Bearbeitung...",
  "bulk.statusQueuedEllipsis": "In Warteschlange...",
  "bulk.loadingResults": "Ergebnisse werden geladen...",
  "bulk.outOfQuotaTitle": "Extraktionskontingent aufgebraucht",
  "bulk.outOfQuotaMessage": "Deine Tarifaufrufe und dein Zusatzguthaben sind aufgebraucht. Kaufe 100 Guthabenpunkte für 10 € oder prüfe die Verlängerung deines Tarifs.",
  "bulk.outOfQuotaButton": "Guthaben kaufen oder Tarife ansehen",
  "bulk.batchLimitTitle": "Nur 1 Dokument auf einmal",
  "bulk.batchLimitMessage": "Bis zu {count} Dokumente pro Upload. Teile die Dateien auf mehrere Stapel auf.",
  "bulk.docProcessFailed": "Dieses Dokument konnte nicht verarbeitet werden.",
  "bulk.optimizingHint": "Route und Adressen werden optimiert...",
  "bulk.locationsRouteLabel": "Orte / Route ({count})",
  "bulk.originLabel": "Start",
  "bulk.destinationLabel": "Ziel",
  "bulk.notSet": "Nicht festgelegt",
  "bulk.producerLabel": "Produktionsfirma",
  "bulk.errorProcessOneDoc": "Ein Dokument konnte nicht verarbeitet werden",
  "bulk.errorSaveTrip": "Die Fahrt konnte nicht gespeichert werden",
  "bulk.toastReusedDocs": "Es wurden {count} bereits hochgeladene Dokument(e) wiederverwendet",
  "bulk.toastAlreadySavedDocs": "{count} Dokument(e) sind bereits gespeichert. Sie werden nicht dupliziert.",
  "bulk.toastSavedTrips": "{count} Fahrten gespeichert",
  "bulk.purposeDefault": "Dreh",
  "bulk.purposeWithProducer": "Dreh: {producer}",
  "bulk.originalDocumentName": "Originaldokument",
  "bulk.aiProcess": "Mit KI verarbeiten",
  "bulk.examplePlaceholder": "Beispiel:\ndate,projectName,reason,origin,stop1,destination,km\n20-09-2025,Mein Projekt,Dreh,\"Plaza Mayor 1, 28012 Madrid\",\"Puerta del Sol 1, 28013 Madrid\",\"Plaza de Cibeles 1, 28014 Madrid\",2.5",
  "bulk.errorNoValidTrips": "Keine gültigen Fahrten zum Import gefunden",
  "bulk.toastImportedTrips": "{count} Fahrten importiert",
  "bulk.toastFailedTrips": "{count} Fahrten fehlgeschlagen",
  "bulk.toastCsvLoaded": "CSV geladen",
  "bulk.errorCsvRead": "CSV konnte nicht gelesen werden",
  "bulk.errorLoginDrive": "Bitte anmelden, um aus Drive zu importieren",
  "bulk.promptDriveLink": "Google-Drive-Link oder CSV-fileId einfügen",
  "bulk.errorDetectFileId": "fileId konnte nicht erkannt werden",
  "bulk.errorDriveDownload": "Drive-Download fehlgeschlagen",
  "bulk.toastCsvImportedDrive": "CSV aus Drive importiert",
  "bulk.errorMaxDocuments": "Maximal 20 Dokumente auf einmal",
  "bulk.errorOnlyPdf": "PDF, Bilder, Excel, CSV, TSV, TXT oder DOCX auswählen.",
  "bulk.errorNotAuthenticated": "Du bist nicht angemeldet",
  "bulk.errorUploadNone": "Kein Dokument konnte hochgeladen werden",
  "bulk.toastUploadedDocs": "{count} Dokumente hochgeladen",
  "bulk.toastFailedDocs": "{count} Dokumente fehlgeschlagen",
  "bulk.errorUploadDoc": "Fehler beim Hochladen des Dokuments",
  "bulk.noLocationsFound": "Keine Orte gefunden.",
  "bulk.saveTrip": "Fahrt speichern",

  // Plan limits
  "limits.maxTripsReached": "Du hast das Limit für aktive Fahrten erreicht. Lösche einige oder upgrade deinen Plan.",
  "limits.maxAITripsReached": "Du hast das Limit für KI-erstellte Fahrten erreicht. Lösche einige oder upgrade deinen Plan.",
  "limits.maxNonAITripsReached": "Du hast das Limit für manuelle Fahrten erreicht. Lösche einige oder upgrade deinen Plan.",
  "limits.maxProjectsReached": "Du hast das Limit für aktive Projekte erreicht. Archiviere einige oder upgrade deinen Plan.",
  "limits.maxStopsReached": "Du hast das Limit für Stopps pro Fahrt erreicht (maximal {limit}).",
  "limits.csvImportExceedsLimit": "Die CSV enthält mehr Fahrten als du importieren kannst. Maximum: {limit}",
  "limits.calendarImportExceedsLimit": "Der Kalender enthält mehr Termine als du importieren kannst. Maximum: {limit}",
  "limits.driveImportExceedsLimit": "Drive enthält mehr Dateien als du importieren kannst. Maximum: {limit}",
  "limits.tripLimitWarning": "Fahrten: {current}/{limit}",
  "limits.projectLimitWarning": "Projekte: {current}/{limit}",
  "limits.aiLimitWarning": "KI-Extraktionen: {current}/{limit}",
  "limits.upgradePlan": "Plan upgraden",
  "limits.planBasic": "Basic Plan",
  "limits.planPro": "Pro Plan",
  "limits.maxTemplatesReached": "Du hast das Limit für Routenvorlagen erreicht. Lösche einige oder upgrade deinen Plan.",
  "limits.maxReportsPerMonthReached": "Du hast das Limit von 1 Bericht pro Monat im Basic-Plan erreicht. Upgrade auf Pro für unbegrenzte Berichte.",
  "plans.features.trips200": "200 aktive Fahrten",

  // Plans page
  "nav.plans": "Pläne",
  "plans.title": "Wähle deinen Plan",
  "plans.subtitle": "Deine Fahrten nach Projekt organisiert und das Kilometergeld fertig für Produktion und Finanzamt.",
  "plans.billingMonthly": "Monatlich",
  "plans.billingAnnual": "Jährlich",
  "plans.annualBadge": "-54 %",
  "plans.perYear": "pro Jahr",
  "plans.annualEquiv": "Entspricht 4,17 €/Monat — 54 % gespart",
  "plans.cancelAnytime": "Keine Bindung: jederzeit kündbar.",
  "plans.basic.name": "Kostenlos",
  "plans.basic.description": "Unbegrenzte Fahrten und Berichte, dauerhaft gratis.",
  "plans.pro.name": "Pro",
  "plans.pro.description": "Callsheets hochladen und abrechnen, ohne zu tippen.",
  "plans.forever": "dauerhaft",
  "plans.perMonth": "pro Monat",
  "plans.currentPlan": "Aktueller Plan",
  "plans.upgradeToPro": "Auf Pro upgraden",
  "plans.mostPopular": "Am beliebtesten",
  "plans.sidebar.free": "Kostenloser Plan",
  "plans.sidebar.upgrade": "Auf Pro upgraden",
  "plans.sidebar.manage": "Plan verwalten",
  "plans.features.trips20": "20 aktive Fahrten",
  "plans.features.trips2000": "2000 aktive Fahrten",
  "plans.features.unlimitedTrips": "Unbegrenzte Fahrten",
  "plans.features.projects3": "3 Projekte",
  "plans.features.projects30": "30 Projekte",
  "plans.features.unlimitedProjects": "Unbegrenzte Projekte",
  "plans.features.ai5": "5 KI-Extraktionen/Monat",
  "plans.features.ai3": "3 KI-Callsheets/Monat",
  "plans.features.ai60": "60 KI-Callsheets/Monat",
  "plans.features.ai400Annual": "400 KI-Callsheets pro Abonnementjahr",
  "plans.features.customAI": "Individuelle KI-Extraktionen",
  "plans.features.stops10": "10 Stopps pro Fahrt",
  "plans.features.stops25": "25 Stopps pro Fahrt",
  "plans.features.unlimitedStops": "Unbegrenzte Stopps",
  "plans.features.csvExport": "CSV-Export",
  "plans.features.allExports": "Alle Exporte",
  "plans.features.basicReports": "Basisberichte",
  "plans.features.advancedReports": "Erweiterte Berichte",
  "plans.features.customReports": "Individuelle Berichte",
  "plans.features.calendarSync": "Google-Calendar-Integration",
  "plans.features.noCalendarSync": "Keine Google-Calendar-Synchronisation",
  "plans.features.routeTemplates": "Routen-Vorlagen",
  "plans.features.routeTemplates5": "5 Routen-Vorlagen",
  "plans.features.routeTemplates50": "50 Routen-Vorlagen",
  "plans.features.unlimitedTemplates": "Unbegrenzte Vorlagen",
  "plans.features.costAnalysis": "Kostenanalyse",
  "plans.features.fullAnalytics": "Vollständige Analysen",
  "plans.features.prioritySupport": "Priorisierter Support",
  "plans.features.dedicatedSupport": "Dedizierter Support",
  "plans.features.sla": "Garantiertes SLA",
  "plans.features.customIntegrations": "Individuelle Integrationen",
  "plans.features.reports1": "1 gespeicherter Bericht",
  "plans.features.reportsUnlimited": "Unbegrenzte Berichte",
  "plans.features.callsheet1": "1 Callsheet auf einmal",
  "plans.features.callsheetBulk20": "Bis zu 20 Callsheets pro Upload",
  "plans.features.callsheetBatch3": "Bis zu 3 Callsheets pro Upload",
  "plans.features.byoOpenrouter": "Eigener OpenRouter-Schlüssel: KI-Modell frei wählbar (multimodal)",
  "plans.upgradeButton": "Auf Pro upgraden",
  "plans.checkoutSuccess": "Zahlung abgeschlossen. Dein Pro-Plan wird aktiviert.",
  "plans.checkoutCancelled": "Die Zahlung wurde abgebrochen und es wurde nichts berechnet.",
  "plans.checkoutError": "Der sichere Stripe-Checkout konnte nicht geöffnet werden.",
  "plans.portalError": "Die Abo-Verwaltung konnte nicht geöffnet werden.",

  "tripDetail.title": "Fahrt-Details",
  "tripDetail.date": "Datum",
  "tripDetail.project": "Projekt",
  "tripDetail.driver": "Fahrer",
  "tripDetail.currentUser": "Aktueller Nutzer",
  "tripDetail.purpose": "Produktionsfirma oder Auftraggeber",
  "tripDetail.route": "Route",
  "tripDetail.totalDistance": "Gesamtdistanz",
  "tripDetail.costBreakdown": "Kostenaufschlüsselung",
  "tripDetail.customRate": "Individueller Satz",
  "tripDetail.invoicesTitle": "Rechnungen für Kraftstoff und Wartung",
  "tripDetail.attach": "Anhängen",
  "tripDetail.attachInvoice": "Rechnung anhängen",
  "tripDetail.invoiceAttachedTitle": "Rechnung angehängt",
  "tripDetail.invoiceAttachedBody": "Die KI-Extraktion startet automatisch.",
  "tripDetail.onlyOneInvoice": "Bitte immer nur 1 Rechnung anhängen.",
  "tripDetail.missingProjectIdForInvoice": "Diese Fahrt hat kein zugeordnetes Projekt. Ordne sie einem Projekt zu, damit die Rechnung unter Projekten erscheint.",
  "tripDetail.invoiceExtracting": "KI-Extraktion läuft…",
  "tripDetail.invoiceCancelled": "KI-Extraktion abgebrochen",
  "tripDetail.totalDocumentedEmpty": "—",
  "tripDetail.invoiceStatusLabel": "Status",
  "tripDetail.totalDocumented": "Dokumentiert gesamt: {amount}",
  "tripDetail.mapSetupTitle": "Google Maps einrichten",
  "tripDetail.mapSetupBody": "Um die Karte zu sehen, konfiguriere Google Maps über Umgebungsvariablen.",
  "tripDetail.saveToken": "Speichern",
  "tripDetail.mapNotConfiguredTitle": "Karte nicht konfiguriert",
  "tripDetail.mapNotConfiguredBody": "VITE_GOOGLE_MAPS_BROWSER_KEY fehlt (und in Produktion GOOGLE_MAPS_SERVER_KEY in Vercel).",
  "tripDetail.mapLoadErrorTitle": "Karte konnte nicht geladen werden",
  "tripDetail.mapLoadError": "Route konnte nicht geladen werden. Prüfe die Google-Maps-Konfiguration.",
  "tripDetail.mapNoRoute": "Keine Route für diese Fahrt gefunden.",
  "tripDetail.mapLoading": "Karte wird geladen…",
  "tripDetail.noDocuments": "Keine Dokumente angehängt",
  "tripDetail.attachDocument": "Dokument anhängen",
  "tripDetail.tabMap": "Karte",
  "tripDetail.tabDocument": "Dokument",
  "tripDetail.errorTitle": "Fehler",
  "tripDetail.authRequired": "Du bist nicht angemeldet",
  "tripDetail.attachSaveFailed": "Anhänge konnten nicht gespeichert werden",
  "tripDetail.attachSavedBody": "{count} Datei(en) angehängt.",
  "tripDetail.attachFailed": "Datei konnte nicht angehängt werden",
  "tripDetail.previewLoadFailed": "Vorschau konnte nicht geladen werden.",
  "tripDetail.previewFrameTitle": "Vorschau",
  "tripDetail.previewUnavailable": "Vorschau ist im Browser nicht verfügbar.",
  "tripDetail.backToDocuments": "Dokumente",
  "tripDetail.openInNewTab": "In neuem Tab öffnen",
  "tripDetail.downloadFile": "Datei herunterladen",
  "tripDetail.driveFetchFailed": "Download aus Drive fehlgeschlagen.",

  "projectDetail.totalKm": "Gesamt-kilometer",
  "projectDetail.shootingDays": "Drehtage",
  "projectDetail.kmPerDay": "Km pro Drehtag",
  "projectDetail.co2Estimated": "CO₂-Emissionen (geschätzt)",
  "projectDetail.callSheetsTitle": "Projekt-Callsheets",
  "projectDetail.uploadCallSheets": "Callsheets hochladen (bis zu 20)",
  "projectDetail.noCallSheets": "Noch keine Callsheets für dieses Projekt hochgeladen.",
  "projectDetail.invoicesTitle": "Projekt-Rechnungen",
  "projectDetail.attachInvoice": "Rechnung anhängen",
  "projectDetail.confirmDeleteInvoice": "Diese Rechnung löschen? Dabei wird auch das KI-Ergebnis gelöscht.",
  "projectDetail.toastProjectMismatch": "Das von der KI erkannte Projekt passt nicht, aber die Fahrt wird trotzdem erstellt. Bitte Ergebnis prüfen.",
  "projectDetail.toastMissingDate": "Datum konnte nicht extrahiert werden. Bitte manuell prüfen.",
  "projectDetail.toastMissingLocations": "Orte konnten nicht extrahiert werden. Bitte manuell prüfen.",
  "projectDetail.toastTripCreatedFromAi": "Fahrt aus Projekt-KI erstellt",
  "projectDetail.toastTripCreatedFromAiFailed": "KI-erstellte Fahrt konnte nicht gespeichert werden",
  "projectDetail.toastTripsCreatedFromAi": "{count} Fahrt(en) aus KI gespeichert.",
  "projectDetail.toastTripsCreatedFromAiFailed": "{count} Fahrt(en) aus KI konnten nicht gespeichert werden.",
  "projectDetail.toastTripsCreatedFromAiPartial": "Gespeichert: {saved}, fehlgeschlagen: {failed}.",
  "projectDetail.toastTripCreatedFromAiError": "Fehler beim Erstellen der Fahrt aus der Extraktion: {message}",
  "projectDetail.toastDocumentUploaded": "Dokument hochgeladen.",
  "projectDetail.toastOpenPdfError": "Fehler beim Öffnen des PDFs: {message}",
  "projectDetail.toastStoragePathMissing": "Dateipfad nicht verfügbar.",
  "projectDetail.toastCallsheetDeleted": "Callsheet gelöscht",
  "projectDetail.toastDeleteError": "Fehler beim Löschen: {message}",
  "projectDetail.toastReprocessingStarted": "Neuverarbeitung gestartet",
  "projectDetail.toastExtractionStarted": "Extraktion gestartet. Der Prozess beginnt in Kürze.",
  "projectDetail.toastExtractionStartedShort": "Extraktion gestartet",
  "projectDetail.toastProcessingCancelled": "Verarbeitung beim Schließen des Projekts abgebrochen.",
  "projectDetail.toastExtractionStartError": "Fehler beim Starten der Extraktion: {message}",
  "projectDetail.toastInvalidSession": "Ungültige Sitzung",
  "projectDetail.toastWorkerExecuted": "Worker ausgeführt: {count} Jobs verarbeitet",
  "projectDetail.toastWorkerError": "Fehler beim Ausführen des Workers: {message}",
  "projectDetail.toastOpenDocumentError": "Fehler beim Öffnen des Dokuments: {message}",
  "projectDetail.toastInvoiceNoJob": "Diese Rechnung hat keinen zugehörigen Extraktions-Job",
  "projectDetail.toastInvoiceDeleted": "Rechnung gelöscht",
  "projectDetail.toastInvoiceLinkedToTrip": "Diese Rechnung gehört zu einer Fahrt. Bitte im zugehörigen Trip löschen.",
  "projectDetail.noInvoices": "Noch keine Rechnungen für dieses Projekt hochgeladen.",
  "projectDetail.discardAll": "Alle verwerfen",
  "projectDetail.saving": "Speichert...",
  "projectDetail.saveTrips": "{count} Fahrten speichern",
  "trips.toastTripSaveFailedTitle": "Fahrt konnte nicht gespeichert werden",
  "trips.toastTripSaveFailedBody": "Die Änderung hat die Datenbank nicht erreicht. Verbindung prüfen oder neu anmelden und erneut versuchen.",
  "projectDetail.review": "Prüfen",
  "projectDetail.cancelled": "Abgebrochen",
  "projectDetail.failed": "Fehler",
  "projectDetail.cancelProcessing": "Verarbeitung abbrechen",
  "projectDetail.tripLabel": "Fahrt",
  "projectDetail.outOfQuota": "Limit erreicht",
  "projectDetail.reprocess": "Neu verarbeiten",
  "projectDetail.reprocessWithAi": "Mit KI neu verarbeiten",
  "projectDetail.extractDataWithAi": "Daten mit KI extrahieren",
  "projectDetail.processing": "Verarbeitet...",
  "projectDetail.toastDuplicateTripSkipped": "Eine Fahrt mit gleichem Datum und gleicher Route existiert bereits; es wurde kein Duplikat angelegt.",
  "bulk.duplicateTripConfirm": "Eine Fahrt mit gleichem Datum und gleicher Route existiert bereits. Trotzdem speichern?",
  "projectDetail.toastAlreadyProcessing": "Dieses Dokument wird bereits verarbeitet; der Status aktualisiert sich nach Abschluss. Falls es hängen bleibt, versuche es in ein paar Minuten erneut.",
  "projectDetail.processNow": "Jetzt verarbeiten",

  // Project expenses
  "projectExpenses.title": "Projektausgaben",
  "projectExpenses.description": "Belege, die keiner bestimmten Fahrt zugeordnet sind. Scannen oder laden Sie Belege per Kamera oder Drag & Drop hoch.",
  "projectExpenses.total": "Gesamt",
  "projectExpenses.saveError": "Fehler beim Speichern der Ausgabe",
  "expenses.receipt": "Beleg",
  "expenses.receipts": "Belege",

  "vehicleConfig.title": "Fahrzeug- und Kostenparameter",
  "vehicleConfig.subtitle": "Konfiguriere dein Fahrzeug, um Kosten ohne Rechnungen zu schätzen.",
  "vehicleConfig.vehicleType": "Fahrzeugtyp",
  "vehicleConfig.fuelConsumption": "Kraftstoffverbrauch",
  "vehicleConfig.fuelPrice": "Kraftstoffpreis",
  "vehicleConfig.evConsumption": "Verbrauch (kWh/100km)",
  "vehicleConfig.energyPrice": "Strompreis (€/kWh)",
  "vehicleConfig.maintenancePerKm": "Wartung (€/km)",
  "vehicleConfig.otherPerKm": "Sonstiges (€/km)",
  "vehicleConfig.estimatedFuelPerKm": "Energie geschätzt (€/km)",
  "vehicleConfig.typeUnknown": "Nicht angegeben",
  "vehicleConfig.typeGasoline": "Benzin",
  "vehicleConfig.typeDiesel": "Diesel",
  "vehicleConfig.typeEv": "Elektro",
  "vehicleConfig.cancel": "Abbrechen",
  "vehicleConfig.save": "Speichern",
  "vehicleConfig.saving": "Wird gespeichert…",
  "vehicleConfig.toastSaving": "Konfiguration wird gespeichert…",
  "vehicleConfig.toastSaved": "Konfiguration gespeichert",
  "vehicleConfig.invalidNumber": "Ungültige Zahl",

  "reports.verifyTitle": "Steuerbericht erstellen",
  "reports.verifyChecklistTitle": "Checkliste vor Export",
  "reports.verifyChecklistBody": "Das System hat die Fahrten im ausgewählten Zeitraum auf mögliche Probleme geprüft.",
  "reports.verifyNoProblems": "Keine potenziellen Probleme gefunden. Bereit zum Erstellen.",
  "reports.verifyFoundWarnings": "{count} Warnung(en) gefunden",
  "reports.verifyContinueOrReview": "Du kannst fortfahren oder die Fahrten vorher prüfen.",
  "reports.back": "Zurück",
  "reports.generateReport": "Bericht erstellen",
  "reports.title": "Berichte",
  "reports.subtitle": "Erstelle und verwalte Kilometerberichte",
  "reports.generateNew": "Neuen Bericht erstellen",
  "reports.project": "Projekt",
  "reports.selectProject": "Projekt auswählen",
  "reports.allProjects": "Alle Projekte",
  "reports.month": "Monat",
  "reports.year": "Jahr",
  "reports.from": "Von",
  "reports.to": "Bis",
  "reports.toastInvalidRangeTitle": "Ungültiger Zeitraum",
  "reports.toastInvalidRangeBody": "Das Datum 'Von' darf nicht nach 'Bis' liegen.",
  "reports.tableGeneratedAt": "Erstellt am",
  "reports.tablePeriod": "Berichtszeitraum",
  "reports.tableActions": "Aktionen",
  "reports.view": "Ansehen",
  "reports.warningImprobableDistance": "Unwahrscheinliche Distanz",
  "reports.warningZeroDistance": "Distanz ist 0 (oder ungültig)",
  "reports.warningMissingPurpose": "Reisezweck fehlt",
  "reports.toastGeneratedTitle": "Bericht erstellt",
  "reports.toastGeneratedBody": "Der Steuerbericht wurde erfolgreich erstellt.",

  "reportView.filePrefix": "bericht",
  "reportView.sheetName": "Bericht",
  "reportView.toastExportingTitle": "Export nach {format}",
  "reportView.toastExportingBody": "Die Datei wird in Kürze heruntergeladen.",
  "reportView.toastPdfDownloadedTitle": "PDF heruntergeladen",
  "reportView.toastPdfDownloadedBody": "Die Datei wurde erfolgreich heruntergeladen.",
  "reportView.toastExportErrorTitle": "Exportfehler",
  "reportView.toastExportErrorBody": "Die Datei konnte nicht erstellt werden. Bitte versuche es erneut.",
  "reportView.backToReports": "Zurück zu Berichten",
  "reportView.backShort": "Zurück",
  "reportView.export": "Exportieren",
  "reportView.exportExcel": "Excel (.xlsx)",
  "reportView.exportPdf": "PDF",
  "reportView.exportCsv": "CSV",
  "reportView.exportZip": "ZIP mit Dokumentation herunterladen",
  "reportView.exportZipPreparing": "Dokumente werden vorbereitet...",
  "reportView.exportZipDone": "ZIP heruntergeladen",
  "reportView.exportZipEmpty": "Keine Dokumente mit diesem Bericht verbunden",
  "reportView.exportZipError": "Fehler beim Erstellen des ZIPs",
  "reportView.exportZipProOnly": "Nur im Pro-Plan verfügbar",
  "reportView.print": "Drucken",
  "reportView.saveReport": "Speichern",
  "reportView.toastSaveErrorTitle": "Bericht konnte nicht gespeichert werden",
  "reportView.toastSaveErrorBody": "Der Bericht bleibt geöffnet. Prüfe die Verbindung und versuche erneut zu speichern.",
  "reportView.toastSavedTitle": "Bericht gespeichert",
  "reportView.toastSavedBody": "Der Bericht wurde in der Liste gespeichert.",
  "reportView.notFoundTitle": "Bericht nicht gefunden",
  "reportView.notFoundBody": "Dieser Bericht existiert nicht oder wurde gel├Âscht.",
  "reportView.reportTitle": "Fahrtenbuch",
  "reportView.periodLabel": "Zeitraum",
  "reportView.driverLabel": "Fahrer",
  "reportView.addressLabel": "Adresse",
  "reportView.licensePlateLabel": "Kennzeichen",
  "reportView.projectLabel": "Projekt",
  "reportView.ratePerKmLabel": "Satz pro km",
  "reportView.passengerSurchargeLabel": "Mitfahrer-Zuschlag",
  "reportView.mergePassengers": "Mitfahrer-Zuschlag ins Kilometergeld einrechnen",
  "reportView.colReimbursement": "Erstattung",
  "reportView.totalReimbursementLabel": "Gesamterstattung",
  "reportView.colDate": "Datum",
  "reportView.colProject": "Projekt",
  "reportView.colCompanyProducer": "Firma/Produzent",
  "reportView.colRoute": "Route",
  "reportView.colPassengers": "Passagiere",
  "reportView.colPassengersShort": "Mitf.",
  "reportView.colDistance": "Distanz",
  "reportView.colDistanceKm": "Distanz (km)",
  "reportView.totalDistanceLabel": "Gesamtkilometer",
  "reportView.totalShort": "Summe",
  "reportView.pdfLanguage": "PDF-Sprache",

  "dashboard.actionUploadCallsheet": "Callsheet hochladen",
  "dashboard.actionAddTrip": "Fahrt hinzufügen",
  "dashboard.kpiBillableMonth": "€ abrechenbar (Monat)",
  "dashboard.kpiKmMonth": "Kilometer (Monat)",
  "dashboard.kpiTripsMonth": "Fahrten (Monat)",
  "dashboard.kpiCo2Month": "CO₂ (Monat)",
  "dashboard.vsPrevMonth": "vs. Vormonat",
  "dashboard.treePerYearShort": "Jährliche Aufnahme von etwa {trees} ausgewachsenem Baum",
  "dashboard.treesPerYearShort": "Jährliche Aufnahme von etwa {trees} ausgewachsenen Bäumen",
  "dashboard.attentionUnavailable": "Die Hinweise konnten nicht aktualisiert werden. Bitte erneut versuchen.",
  "dashboard.attentionTitle": "Braucht deine Aufmerksamkeit",
  "dashboard.attentionEmpty": "Alles in Ordnung",
  "dashboard.attentionCallsheetFailed": "Callsheet fehlgeschlagen",
  "dashboard.attentionCallsheetReview": "Callsheet zu überprüfen",
  "dashboard.attentionMore": "+{count} weitere unter Fahrten",
  "dashboard.aiCounterTitle": "KI-Callsheets",
  "dashboard.aiCounterRenews": "Erneuert sich am 1. {month}",
  "dashboard.aiCounterExhausted": "Monatslimit erreicht",
  "dashboard.aiCounterNearLimit": "Nur noch wenige diesen Monat",
  "dashboard.reportReadyTitle": "Bericht für {month} bereit",
  "dashboard.reportReadyCta": "PDF erstellen",
  "dashboard.carMarginTitle": "Netto-Marge deines Autos",
  "dashboard.carMarginMonth": "Dein Auto hat dir diesen Monat ~{amount} netto gebracht",
  "dashboard.carMarginDetail": "Abgerechnet {billed} · geschätzte Kosten {cost}",
  "dashboard.carMarginPerKmDetail": "{rate} Kilometergeld − {cost} reale Kosten pro km",
  "dashboard.aiChipLabel": "KI-Callsheets",
  "dashboard.aiChipAnnual": "KI-Callsheets/Jahr",
  "dashboard.aiChipMonthly": "KI-Callsheets/Monat",
  "dashboard.reportReadyDesc": "{count} Fahrten erfasst. PDF erstellen und an die Produktion senden.",
  "dashboard.carMarginMissing": "Trage Verbrauch, Kraftstoffpreis und Kosten pro km in den Einstellungen ein, um dies zu berechnen.",
  "dashboard.proUsageTitle": "% berufliche Nutzung",
  "dashboard.proUsageDetail": "{workKm} berufliche km von {totalKm} km gesamt ({year})",
  "dashboard.proUsageMissing": "Trage die jährlichen Gesamtkilometer deines Autos in den Einstellungen ein (aus Werkstattrechnung oder Pickerl).",
  "dashboard.monthlyBarsTitle": "Km & € pro Monat",
  "settings.annualCarTotalKm": "Gesamtkilometer des Autos dieses Jahr",
  "settings.annualCarTotalKmHint": "Tachostand oder Werkstattrechnung/Pickerl; wird für den % beruflicher Nutzung verwendet.",
  "settings.carCostsTitle": "Autokosten",
  "settings.carCostsHint": "Wird für die Karte \"Netto-Marge deines Autos\" im Dashboard verwendet.",
  "settings.fuelPricePerLiter": "Kraftstoffpreis (€/L)",
  "settings.electricityPricePerKwh": "Strompreis (€/kWh)",
  "settings.maintenanceEurPerKm": "Wartung (€/km)",
  "settings.otherEurPerKm": "Sonstige Kosten (€/km)",
  "bulk.aiQuotaLine": "KI-Callsheets diesen Monat: {used}/{limit}",
  "bulk.aiQuotaAnnualLine": "KI-Callsheets in diesem Abonnementjahr: {used}/{limit}",

  "reportPdf.title": "Fahrtkostenabrechnung (Kilometergeld)",
  "reportPdf.colPurpose": "Zweck",
  "reportPdf.colRate": "€/km",
  "reportPdf.colAmount": "Betrag",
  "reportPdf.tripsLabel": "Fahrten",
  "reportPdf.totalKmLabel": "Kilometer gesamt",
  "reportPdf.travelCosts": "Fahrtkosten (Kilometergeld)",
  "reportPdf.expensesTitle": "Auslagen",
  "reportPdf.expenseToll": "Maut",
  "reportPdf.expenseParking": "Parken",
  "reportPdf.expenseFuel": "Kraftstoff",
  "reportPdf.expenseOther": "Sonstige",
  "reportPdf.receiptsAnnex": "Belege im Anhang (ZIP-Export).",
  "reportPdf.grandTotal": "Gesamtbetrag",
  "reportPdf.inclPassengerSurcharge": "inkl. Mitfahrer-Zuschlag",
  "reportPdf.inclExpenses": "inkl. Auslagen",
  "reportPdf.totalBoxLabel": "Gesamt",
  "reportPdf.shootDayOne": "1 Drehtag",
  "reportPdf.shootDays": "{count} Drehtage",
  "reportPdf.co2Line": "CO2-Ausstoß: {kg} kg — entspricht der jährlichen Bindung von ca. {trees} Bäumen.",
  "reportPdf.co2Only": "CO2-Ausstoß: {kg} kg.",
  "reportPdf.colCo2": "CO2 (kg)",
  "reportPdf.totalCo2Label": "CO2 gesamt",
  "dashboard.setupTitle": "Profil vervollständigen — dann rechnet sich alles von selbst",
  "dashboard.setupBothMissing": "Es fehlen dein km-Satz und deine Basisadresse: ohne sie können weder Distanzen noch Beträge berechnet werden.",
  "dashboard.setupRateMissing": "Es fehlt dein km-Satz: ohne ihn können die Beträge deiner Fahrten nicht berechnet werden.",
  "dashboard.setupBaseMissing": "Es fehlt deine Basisadresse: mit ihr füllen sich Start und Distanz beim Anlegen einer Fahrt von selbst.",
  "dashboard.setupCta": "In den Einstellungen ergänzen",
  "reportView.tripsCount": "{count} Fahrten",
  "reportView.tripsCountOne": "1 Fahrt",
  "reportView.contentMenu": "Berichtsinhalt",
  "reportView.optCo2": "CO2-Spalte",
  "reportView.optTrees": "Baum-Äquivalent",
  "reportView.optSource": "Quellenangabe",
  "reportView.optSignature": "Unterschriftsblock",
  "reportPdf.co2Source": "Quelle: Umweltbundesamt/JEC (Tank-to-Wheel); Strom: Ember/OWID {year}; ~{treeKg} kg CO2 pro Baum und Jahr.",
  "reportPdf.signature": "Datum, Unterschrift",
  "reportPdf.footer": "Erstellt mit Fahrtenbuch Pro · fahrtenbuchpro.com",
  "reportPdf.pageOf": "Seite {page} von {pages}",

  "advancedRoutes.createTemplateTitle": "Neue Vorlage erstellen",
  "advancedRoutes.editTemplateTitle": "Vorlage bearbeiten",
  "advancedRoutes.basicInfo": "Grundinformationen",
  "advancedRoutes.templateName": "Vorlagenname",
  "advancedRoutes.category": "Kategorie",
  "advancedRoutes.categoryBusiness": "Geschäftlich",
  "advancedRoutes.categoryCommute": "Pendeln",
  "advancedRoutes.categoryClient": "Kunde",
  "advancedRoutes.categoryOther": "Sonstiges",
  "advancedRoutes.routeDetails": "Routendetails",
  "advancedRoutes.startLocation": "Startort",
  "advancedRoutes.endLocation": "Zielort",
  "advancedRoutes.distanceKm": "Distanz (km)",
  "advancedRoutes.estimatedTimeMin": "Geschätzte Zeit (min)",
  "advancedRoutes.additionalDetails": "Zusätzliche Details",
  "advancedRoutes.description": "Beschreibung",
  "advancedRoutes.descriptionPlaceholder": "Beschreibung eingeben",
  "advancedRoutes.cancel": "Abbrechen",
  "advancedRoutes.createTemplate": "Vorlage erstellen",
  "advancedRoutes.saveChanges": "Änderungen speichern",
  "advancedRoutes.pageTitle": "Routenvorlagen",
  "advancedRoutes.pageSubtitle": "Speichere häufige Routen als wiederverwendbare Vorlagen.",
  "advancedRoutes.statTotalTemplates": "Vorlagen insgesamt",
  "advancedRoutes.statAvgDistance": "Durchschnittliche Distanz",
  "advancedRoutes.statMostUsed": "Am häufigsten genutzt",
  "advancedRoutes.none": "Keine",
  "advancedRoutes.categoryAll": "Alle Kategorien",
  "advancedRoutes.toastLoadError": "Vorlagen konnten nicht geladen werden",
  "advancedRoutes.toastLoginRequired": "Bitte anmelden, um Vorlagen zu speichern",
  "advancedRoutes.toastNameRequired": "Gib der Vorlage einen Namen",
  "advancedRoutes.saveAsTemplate": "Als Vorlage speichern",
  "advancedRoutes.createTemplateDesc": "Speichern Sie diese Route zur Wiederverwendung in zukünftigen Fahrten.",
  "advancedRoutes.save": "Speichern",
  "advancedRoutes.errorUpdateFailed": "Vorlage konnte nicht aktualisiert werden",
  "advancedRoutes.errorCreateFailed": "Vorlage konnte nicht erstellt werden",
  "advancedRoutes.toastUpdated": "Vorlage aktualisiert",
  "advancedRoutes.toastCreated": "Vorlage erstellt",
  "advancedRoutes.edit": "Bearbeiten",
  "advancedRoutes.use": "Verwenden",
  "advancedRoutes.loading": "Laden…",
  "advancedRoutes.noTemplatesInCategory": "Keine Vorlagen in dieser Kategorie. Erstelle deine erste Vorlage, um loszulegen.",
  "advancedRoutes.toastSaveFailed": "Vorlage konnte nicht gespeichert werden",
  "advancedRoutes.toastUsesUpdateFailed": "Zähler konnte nicht aktualisiert werden",

  "advancedCosts.pageTitle": "Kostenanalyse",
  "advancedCosts.pageSubtitle": "Personalisierte Kostenanalyse basierend auf deiner Fahrzeugkonfiguration.",
  "advancedCosts.uploadInvoice": "Rechnung hochladen",
  "advancedCosts.uploadShort": "Hochladen",
  "advancedCosts.periodAllTime": "Gesamte Zeit",
  "advancedCosts.periodLastMonth": "Letzter Monat",
  "advancedCosts.periodLast3Months": "Letzte 3 Monate",
  "advancedCosts.periodLast6Months": "Letzte 6 Monate",
  "advancedCosts.periodLastYear": "Letztes Jahr",
  "advancedCosts.tabSummary": "Übersicht",
  "advancedCosts.tabMonthly": "Monatliche Kosten",
  "advancedCosts.monthlyChartTitle": "Monatliche Entwicklung",
  "advancedCosts.statTotalDistance": "Gesamtdistanz",
  "advancedCosts.statTotalTrips": "Fahrten insgesamt",
  "advancedCosts.statEstimatedTotalCost": "Geschätzte Gesamtkosten",
  "advancedCosts.statAvgCostPerKm": "Ø Kosten / km",
  "advancedCosts.breakdownTitle": "Grundlegende Kostenaufteilung",
  "advancedCosts.breakdownFuelEnergy": "Kraftstoff / Energie",
  "advancedCosts.breakdownTolls": "Maut",
  "advancedCosts.breakdownParking": "Parken",
  "advancedCosts.breakdownOther": "Sonstiges",
  "advancedCosts.breakdownAvgPerTrip": "Ø Kosten / Fahrt",
  "advancedCosts.assumptionsTitle": "Kostenübersicht",
  "advancedCosts.assumptionFuelPerKm": "Kraftstoff: {amount}/km",
  "advancedCosts.assumptionTollsTotal": "Maut (gesamt): {amount}",
  "advancedCosts.assumptionParkingTotal": "Parken (gesamt): {amount}",
  "advancedCosts.assumptionOtherTotal": "Sonstiges (gesamt): {amount}",
  "advancedCosts.assumptionsHint": "Diese Kosten basieren auf deiner Fahrzeugkonfiguration und Fahrtausgaben.",
  "advancedCosts.warningNoVehicleConfig": "Unvollständige Fahrzeugkonfiguration",
  "advancedCosts.warningNoVehicleConfigDetails": "Du hast deine Fahrzeuginformationen in deinem Profil nicht vollständig eingerichtet. Kraftstoff-/Energiekosten können ohne diese Daten nicht berechnet werden.",
  "advancedCosts.assumptionsEdit": "Hier klicken, um zu bearbeiten.",
  "advancedCosts.projectAnalysisTitle": "Kostenanalyse nach Projekt",
  "advancedCosts.projectLabel": "Projekt:",
  "advancedCosts.allProjects": "Alle Projekte",
  "advancedCosts.tableProject": "Projekt",
  "advancedCosts.tableDistanceAbbr": "Dist.",
  "advancedCosts.tableTrips": "Fahrten",
  "advancedCosts.tableTotal": "Gesamt",
  "advancedCosts.tableEurPerKm": "€/km",
  "advancedCosts.monthlySummaryTitle": "Monatsübersicht",
  "advancedCosts.tableMonth": "Monat",
  "advancedCosts.tableDistance": "Distanz",
  "advancedCosts.tableFuelEnergy": "Kraftstoff / Energie",
  "advancedCosts.tableTolls": "Maut",
  "advancedCosts.tableParking": "Parken",
  "advancedCosts.tableOther": "Sonstiges",
  "advancedCosts.toastSelectProject": "Wähle ein Projekt, um die Rechnung anzuhängen",
  "advancedCosts.toastSupabaseNotConfigured": "Supabase ist nicht konfiguriert",
  "advancedCosts.toastMaxDocuments": "Maximal 20 Dokumente auf einmal",
  "advancedCosts.toastOnlyPdfOrImages": "Nur PDF- oder Bilddateien sind erlaubt",
  "advancedCosts.toastNotAuthenticated": "Du bist nicht angemeldet",
  "advancedCosts.toastUploadedInvoices": "{count} Rechnung(en)/Dokument(e) hochgeladen. Die KI-Extraktion startet automatisch.",
  "advancedCosts.toastFailedDocuments": "{count} Dokument(e) fehlgeschlagen",
  "advancedCosts.errorUploadInvoice": "Fehler beim Hochladen der Rechnung",
  "advancedCosts.chartNoData": "Keine Daten zum Anzeigen.",
  "advancedCosts.chartNoCostsTitle": "Für diesen Zeitraum sind noch keine Kostenbeträge vorhanden.",
  "advancedCosts.chartNoCostsBody": "Konfiguriere dein Fahrzeug oder lade Rechnungen mit Beträgen hoch (oder starte die Extraktion), um Diagramme zu sehen.",
  "advancedCosts.chartSeriesTotal": "Gesamt",
  "advancedCosts.pageSubtitleNew": "Analysiere die tatsächliche Rentabilität deiner Fahrten durch Vergleich von Kosten und Erstattungen.",
  "advancedCosts.periodThisMonth": "Dieser Monat",
  "advancedCosts.periodLastQuarter": "Letztes Quartal",
  "advancedCosts.periodThisYear": "Dieses Jahr",
  "advancedCosts.reimbursement": "Erstattung",
  "advancedCosts.realCost": "Tatsächliche Kosten",
  "advancedCosts.balance": "Bilanz",
  "advancedCosts.profitable": "Rentabel",
  "advancedCosts.notProfitable": "Nicht rentabel",
  "advancedCosts.tripsLabel": "Fahrten",
  "advancedCosts.trip": "Fahrt",
  "advancedCosts.costBreakdown": "Kostenaufschlüsselung",
  "advancedCosts.projectBreakdown": "Rentabilität nach Projekt",
  "advancedCosts.noProjectsInPeriod": "Keine Projekte mit Fahrten in diesem Zeitraum.",
  "advancedCosts.tableCost": "Kosten",
  "advancedCosts.tableReimbursement": "Erstattung",
  "advancedCosts.total": "Gesamt",
  "advancedCosts.infoFooter": "Die Kosten werden basierend auf deiner Fahrzeugkonfiguration und den für jede Fahrt erfassten Ausgaben berechnet.",
  "advancedCosts.loadMoreProjects": "Mehr Projekte laden",
  "advancedCosts.loadMoreTrips": "Mehr Fahrten laden",
  "advancedCosts.remaining": "übrig",

  "advancedEmissions.configTitle": "CO₂-Analyse konfigurieren",
  "advancedEmissions.configSubtitle": "Einstellungen für die CO₂-Analyse festlegen",
  "advancedEmissions.pageTitle": "CO₂-Ranking",
  "advancedEmissions.pageSubtitle": "Bewerte die Umweltwirkung deiner Fahrten und vergleiche sie.",
  "advancedEmissions.austriaNotice": "Die verwendeten CO₂-Emissionsfaktoren (Climatiq UBA Austria 2022, 0,2472 kg CO₂e/km) gelten für Österreich. Wenn dein Land ein anderes ist, sind die angezeigten Werte eine Annäherung auf Basis österreichischer Daten.",
  "advancedEmissions.export": "Exportieren",
  "advancedEmissions.welcomeTitle": "Willkommen bei der CO₂-Analyse",
  "advancedEmissions.welcomeBody": "Erhalte Einblicke in die Umweltwirkung deiner Fahrten. Konfiguriere deine Analyse-Einstellungen, um deinen CO₂-Fußabdruck zu verfolgen und nachhaltigere Optionen zu entdecken.",
  "advancedEmissions.configureButton": "CO₂-Analyse konfigurieren",
  "advancedEmissions.totalEmissions": "Gesamte CO₂-Emissionen",
  "advancedEmissions.totalFootprintTitle": "Gesamter CO₂-Fußabdruck",
  "advancedEmissions.totalFootprintUnit": "kg CO₂",
  "advancedEmissions.compensationTitle": "Anschaulicher Vergleich",
  "advancedEmissions.compensationBody": "Ungefähre Aufnahme innerhalb eines Jahres:",
  "advancedEmissions.treeSingular": "Baum",
  "advancedEmissions.treePlural": "Bäume",
  "advancedEmissions.breakdownTitle": "Projektaufschlüsselung",
  "advancedEmissions.breakdownTitleTrips": "Fahrtenaufschlüsselung",
  "advancedEmissions.trendChartTitle": "Emissionstrend (kg CO₂)",
  "advancedEmissions.trendChartProjected": "Prognose",
  "advancedEmissions.trendChartReal": "Real",
  "advancedEmissions.trendChartWeek": "Woche {week}",
  "advancedEmissions.trendChartNoData": "Keine Daten zum Anzeigen.",
  "advancedEmissions.co2TotalLabel": "CO₂ GESAMT",
  "advancedEmissions.co2PerPassengerLabel": "PRO PERSON",
  "advancedEmissions.tripsLabel": "Fahrten",
  "advancedEmissions.avgEfficiency": "Durchschnittliche Effizienz",
  "advancedEmissions.fuelConsumption": "Kraftstoffverbrauch",
  "advancedEmissions.electricConsumption": "Stromverbrauch",
  "advancedEmissions.treesNeeded": "Benötigte Bäume",
  "advancedEmissions.resultsTitle": "CO₂-Ranking-Ergebnisse ({count})",
  "advancedEmissions.noResultsTitle": "Keine Ergebnisse für diesen Zeitraum",
  "advancedEmissions.noResultsBody": "Ändere den Zeitraum oder füge Fahrten hinzu, um das Ranking zu sehen.",
  "advancedEmissions.metricCo2Kg": "CO₂ (kg)",
  "advancedEmissions.metricEfficiency": "Effizienz (kg/km)",
  "advancedEmissions.metricDistance": "Distanz (km)",
  "advancedEmissions.metricTrips": "Fahrten",
  "advancedEmissions.viewMode": "Ansicht",
  "advancedEmissions.viewModeProjectsOnly": "Nur Projekte",
  "advancedEmissions.viewModeAllTrips": "Alle Fahrten",
  "advancedEmissions.sortBy": "Sortieren nach",
  "advancedEmissions.sortByCo2": "CO₂ (kg)",
  "advancedEmissions.sortByEfficiency": "Effizienz",
  "advancedEmissions.sortByDistance": "Distanz",
  "advancedEmissions.sortByHelp": "Hauptmetrik zum Ranking auswählen",
  "advancedEmissions.timeRange": "Zeitraum",
  "advancedEmissions.allTime": "Gesamter Zeitraum",
  "advancedEmissions.last7Days": "Letzte 7 Tage",
  "advancedEmissions.last30Days": "Letzte 30 Tage",
  "advancedEmissions.last90Days": "Letzte 90 Tage",
  "advancedEmissions.last6Months": "Letzte 6 Monate",
  "advancedEmissions.thisYear": "Dieses Jahr",
  "advancedEmissions.selectPeriodHelp": "Zeitraum für CO₂-Analyse auswählen",
  "advancedEmissions.searchPlaceholder": "Projekt suchen...",
  "advancedEmissions.resetFilters": "Zurücksetzen",
  "advancedEmissions.noFilterResultsTitle": "Keine Ergebnisse",
  "advancedEmissions.noFilterResultsBody": "Keine Ergebnisse für die aktuellen Filter.",
  "advancedEmissions.filterByProjectPlaceholder": "Nach Projekt filtern...",
  "advancedEmissions.sortDirectionAsc": "Aufsteigend",
  "advancedEmissions.sortDirectionDesc": "Absteigend",
  "advancedEmissions.fuelEfficiency": "Kraftstoffeffizienz (L/100km)",
  "advancedEmissions.fuelEfficiencyHelp": "Durchschnittlicher Verbrauch pro 100km (für CO₂-Berechnungen)",
  "advancedEmissions.aboutTitle": "Über CO₂-Berechnungen",
  "advancedEmissions.aboutBody": "CO₂-Emissionen werden anhand von Verbrauch und Fahrzeugtyp berechnet. Diese Analyse hilft, die Umweltwirkung zu verstehen und effizientere Fahrten zu erkennen.",
  "advancedEmissions.cancel": "Abbrechen",
  "advancedEmissions.save": "Einstellungen speichern",
  "advancedEmissions.fallbackTripName": "Fahrt",
  "advancedEmissions.fallbackProjectName": "Projekt",
  "advancedEmissions.ratingVeryLow": "Sehr niedrig",
  "advancedEmissions.ratingLow": "Niedrig",
  "advancedEmissions.ratingModerate": "Mittel",
  "advancedEmissions.ratingHigh": "Hoch",
  "advancedEmissions.ratingVeryHigh": "Sehr hoch",
  "advancedEmissions.trendStable": "Stabil",
  "advancedEmissions.trendNew": "Neu",
  "advancedEmissions.trendImproving": "Verbessernd",
  "advancedEmissions.trendWorsening": "Verschlechternd",
  "advancedEmissions.allProjects": "Alle Projekte",
  "validation.title": "Validierung",
  "validation.excessive": "Übermäßiger Verbrauch: {value} {unit}. Maximum erlaubt ist {max} {unit}.",
  "validation.tooLow": "Verbrauch zu niedrig: {value} {unit}. Realistisches Minimum ist {min} {unit}.",

  "settings.title": "Einstellungen",
  "settings.tabProfile": "Profil",
  "settings.tabApis": "APIs & externe Dienste",
  "settings.tabPersonalization": "Personalisierung",
  "settings.tabLanguage": "Sprache",
  "settings.tabNews": "Neuigkeiten",
  "settings.tabHelp": "Hilfe & Doku",
  "settings.cancel": "Abbrechen",
  "settings.save": "Einstellungen speichern",
  "settings.refresh": "Aktualisieren",
  "settings.toastSaving": "Einstellungen werden gespeichert…",
  "settings.toastSaved": "Einstellungen gespeichert",
  "settings.sessionInvalid": "Ungültige Sitzung.",
  "settings.deleteAccountFailed": "Konto konnte nicht gelöscht werden.",
  "settings.accountDeleted": "Konto gelöscht.",
  "settings.googleConnectFailed": "Verbindung konnte nicht gestartet werden",
  "settings.googleDisconnectFailed": "Verbindung konnte nicht getrennt werden",
  "settings.profileSectionTitle": "Mein Profil",
  "settings.fullName": "Vollständiger Name",
  "settings.vatId": "USt-IdNr.",
  "settings.licensePlate": "Kennzeichen",
  "settings.ratePerKm": "Satz (€/km)",
  "settings.passengerSurcharge": "Zuschlag pro Mitfahrer (€)",
  "settings.ratesSource": "Tarif aus den Einstellungen. Gilt für alle Fahrten und Projekte.",
  "settings.ratesDefaults": "Leere Felder verwenden 0,50 €/km und 0,15 € pro Mitfahrer. Eine eingegebene Null bleibt gültig.",
  "settings.baseAddress": "Basisadresse",
  "settings.city": "Stadt",
  "settings.country": "Land",
  "settings.vehicleSectionTitle": "Fahrzeug & Emissionen",
  "settings.vehicleSectionBody": "Lege Kraftstofftyp und Verbrauch fest, um CO₂ korrekt zu berechnen.",
  "settings.fuelType": "Fahrzeugtyp",
  "settings.fuelTypeUnknown": "Nicht angegeben",
  "settings.fuelTypeGasoline": "Benzin",
  "settings.fuelTypeDiesel": "Diesel",
  "settings.fuelTypeEv": "Elektro",
  "settings.fuelConsumption": "Verbrauch (L/100km)",
  "settings.evConsumption": "Verbrauch (kWh/100km)",
  "settings.gridFactor": "Netzintensität (AT) (kg CO₂/kWh)",
  "settings.gridFactorHelp": "Jahresdurchschnitt des Stromnetzes deines Landes (AT/DE/CZ/HU), Quelle Ember/Our World in Data. Wird einmal jährlich geprüft.",
  "settings.emissionsGridAnnualNote": "* Jahresdurchschnitt der Stromerzeugung des Landes; manuelle jährliche Aktualisierung.",
  "settings.emissionsStaticFuelTitle": "Kraftstofffaktor (statische Tabelle)",
  "settings.emissionsStaticGridTitle": "Stromnetz (Jahresdurchschnitt)",
  "settings.emissionsDataSourceTitle": "Emissionsdatenquelle",
  "settings.emissionsDataSourceBody": "CO₂-Berechnungen verwenden statische Faktoren mit zitierten Quellen; die Genauigkeit kommt vom realen Verbrauch deines Fahrzeugs:",
  "settings.emissionsFactor": "Faktor",
  "settings.emissionsSource": "Quelle",
  "settings.emissionsYear": "Jahr",
  "settings.emissionsRegion": "Region",
  "settings.emissionsActivityId": "Activity ID",
  "settings.emissionsWellToWheel": "* Tank-to-Wheel-Methodik: CO₂ aus der Verbrennung des Kraftstoffs (ohne Raffination und Transport).",
  "settings.emissionsIntensity": "Intensität",
  "settings.emissionsZone": "Zone",
  "settings.emissionsUpdated": "Aktualisiert",
  "settings.deleteAccountTitle": "Konto löschen",
  "settings.deleteAccountBody": "Fahrten, Dokumente, Projekte, Berichte und Einstellungen werden dauerhaft gelöscht. Ein vorhandenes Abonnement wird gekündigt, um Verlängerungen zu verhindern. Dies kann einige Minuten dauern. Bei Unterbrechung erneut drücken, um fortzufahren; bereits gelöschte Daten können nicht wiederhergestellt werden.",
  "settings.deletingAccount": "Löschung läuft. Ausstehende Vorgänge werden abgewartet und Daten entfernt. Dieses Fenster offen lassen.",
  "settings.deleteAccountIncomplete": "Die Löschung ist noch nicht abgeschlossen. Erneut auf Mein Konto löschen drücken, um fortzufahren. Währenddessen können keine neuen Änderungen gespeichert werden.",
  "settings.deleteAccountButton": "Mein Konto löschen",
  "settings.apisGeminiBody": "Serverseitige KI für Callsheet-Parsing",
  "settings.apisInactive": "Inaktiv",
  "settings.apisSavedSelection": "Der Gemini-Status zeigt die gespeicherten Einstellungen. Speichere Änderungen, um sie anzuwenden.",
  "ui.aiProviderUnavailable": "Der ausgewählte KI-Anbieter konnte nicht verwendet werden. Prüfe deine gespeicherten Einstellungen und deinen Tarif. Es wurde kein anderer Anbieter verwendet.",
  "settings.apisActive": "Aktiv",
  "settings.apisOpenRouterTitle": "OpenRouter (Optional)",
  "settings.apisOpenRouterBody": "Eigenen API-Schlüssel verwenden",
  "settings.apisApiKey": "API-Schlüssel",
  "settings.apisGoogleCalendarBody": "Ereignisse synchronisieren",
  "settings.apisConnect": "Verbinden",
  "settings.appearanceTitle": "Darstellung",
  "settings.theme": "Design",
  "settings.current": "aktuell",
  "settings.themeLight": "Hell",
  "settings.themeLightDesc": "Helle Hintergründe und dezenter Glaseffekt.",
  "settings.themeDark": "Dunkel",
  "settings.themeDarkDesc": "Mehr Kontrast für dunkle Umgebungen.",
  "settings.themeHint": "Zwischen hell und dunkel wechseln, ohne andere Styles zu ändern.",
  "settings.backgroundImage": "Hintergrundbild",
  "settings.uploadFromComputer": "Vom Computer hochladen",
  "settings.remove": "Entfernen",
  "settings.none": "Keine",
  "settings.presetBackgrounds": "Voreingestellte Hintergründe",
  "settings.uiOpacity": "UI-Deckkraft",
  "settings.uiBlur": "UI-Unschärfe",
  "settings.backgroundBlur": "Hintergrund-Unschärfe",
  "settings.appVersionTitle": "App-Version",
  "settings.checkUpdates": "Nach Updates suchen",
  "settings.changelogBody": "Neueste Änderungen und Updates ansehen",
  "settings.viewChangelog": "Changelog ansehen",
  "settings.helpTitle": "Hilfe & Dokumentation",
  "settings.docsTitle": "Dokumentation",
  "settings.docsBody": "Lerne alle Funktionen kennen",
  "settings.viewDocs": "Dokumentation ansehen",
  "settings.supportTitle": "Support",
  "settings.supportBody": "Brauchst du Hilfe? Kontaktiere uns",
  "settings.contactSupport": "Support kontaktieren",
  "settings.tourTitle": "Interaktive Tour",
  "settings.tourBody": "Die geführte Tour durch die App erneut ansehen",
  "settings.tourStart": "Tour starten",
  "settings.build": "Build:",

  // Interaktive Tour (OnboardingTour)
  "tour.stepOf": "Schritt {current} von {total}",
  "tour.skip": "Tour überspringen",
  "tour.back": "Zurück",
  "tour.next": "Weiter",
  "tour.finish": "Fertig",
  "tour.welcomeTitle": "Willkommen bei Fahrtenbuch Pro",
  "tour.welcomeBody": "Wir nehmen dich mit auf eine geführte Tour durch die App: Dashboard, Fahrten, Projekte, Berichte und Kalender. Eine Minute und du bist startklar.",
  "tour.kpisTitle": "Dein Monat auf einen Blick",
  "tour.kpisBody": "€ zu fakturieren, Kilometer, Fahrten und CO₂ des Monats, verglichen mit dem Vormonat. Jede Karte führt zu ihrer Seite.",
  "tour.attentionTitle": "KI-Kontingent und Hinweise",
  "tour.attentionBody": "Der Zähler zeigt die diesen Monat verbrauchten Callsheet-Extraktionen. Die Glocke sammelt, was deine Aufmerksamkeit braucht: zu prüfende Callsheets und Fahrten mit seltsamen Daten.",
  "tour.addTripTitle": "Fahrten von Hand anlegen",
  "tour.addTripBody": "Mit \"Fahrt hinzufügen\": der Start geht von deiner Basisadresse aus, die Distanz berechnet sich automatisch über Google Maps — dazu bis zu 25 Stopps, Mitfahrer und Ausgaben mit Beleg.",
  "tour.bulkTitle": "Oder die KI erstellt sie",
  "tour.bulkBody": "Mit \"Massenimport\" lädst du Callsheets als PDF oder Foto hoch und die KI extrahiert Datum, Projekt und Drehorte. Du prüfst und speicherst.",
  "tour.tableTitle": "Deine Fahrten-Tabelle",
  "tour.tableBody": "Filtere nach Projekt und Jahr, wähle mehrere zum Löschen im Stapel und nutze das ⋮-Menü jeder Zeile: Karte ansehen, zum Kalender, bearbeiten, löschen.",
  "tour.projectsTitle": "Projekte",
  "tour.projectsBody": "Jede Produktion ist ein Ordner: Er bündelt Fahrten, Callsheets und Dokumente und vererbt Produktionsfirma und Satz.",
  "tour.reportsTitle": "Berichte",
  "tour.reportsBody": "Hier erstellst du den Kilometergeld-Bericht: Projekt und Zeitraum wählen und als PDF (Deutsch, Englisch oder Spanisch), CSV oder ZIP mit Belegen exportieren.",
  "tour.calendarTitle": "Kalender in beide Richtungen",
  "tour.calendarBody": "Verbinde Google Kalender: mache Termine mit einem Klick zu Fahrten und schicke genauso Fahrten aus der Fahrten-Tabelle in den Kalender.",
  "tour.settingsTitle": "Fang mit deinem Profil an",
  "tour.settingsBody": "Lege in Einstellungen → Profil deinen Kilometersatz und deine Basisadresse fest: Ohne sie gibt es weder Beträge noch automatische Distanz.",
  "tour.planTitle": "Dein Plan und das KI-Kontingent",
  "tour.planBody": "Hier siehst du deinen aktuellen Plan. Pro erhöht die monatlichen Callsheet-Extraktionen und erlaubt deinen eigenen OpenRouter-Schlüssel.",
  "tour.finalTitle": "Alles bereit!",
  "tour.finalBody": "Zum Nachschlagen findest du die Dokumentation und diese Tour in Einstellungen → Hilfe & Docs. Gute Drehtage!",

  // Tutorial des Fahrt-Modals (TripModalTour)
  "tripTour.help": "Formular-Tutorial",
  "tripTour.routeTitle": "Die Route der Fahrt",
  "tripTour.routeBody": "Der Start geht von deiner Basisadresse aus: bleibt er leer, gilt die graue Adresse. Tippe das Ziel und wähle einen Vorschlag; mit \"Stopp hinzufügen\" bis zu 25 Stopps, per Ziehen sortierbar.",
  "tripTour.originModeTitle": "Spezieller Start: verkette deinen Tag",
  "tripTour.originModeBody": "\"Start von meiner Basisadresse\" ist die normale Fahrt von zu Hause. \"Vom letzten Ziel fortsetzen\" füllt den Start mit dem Ziel deiner vorherigen Fahrt — ideal für die zweite Fahrt des Tages. \"Zur Basisadresse zurück\" fixiert das Ziel auf deine Basis für die Heimfahrt.",
  "tripTour.distanceTitle": "Distanz und Satz",
  "tripTour.distanceBody": "Die Distanz berechnet sich automatisch über Google Maps, sobald die Route steht; korrigiere sie von Hand oder berechne mit dem mittleren Button neu. Der Satz ist optional: wenn gesetzt, geht er vor Projekt- und Profilsatz.",
  "tripTour.passengersTitle": "Mitfahrer",
  "tripTour.passengersBody": "Trage ein, wie viele Kolleg:innen mitgefahren sind: ihr Zuschlag pro km wird separat berechnet und bleibt IMMER vom Kilometergeld getrennt, auch im Bericht.",
  "tripTour.expensesTitle": "Ausgaben mit Beleg",
  "tripTour.expensesBody": "Maut, Parken, Kraftstoff und Sonstiges: Betrag in EUR eintragen und das Belegfoto über den Kamera-Button anhängen. Sie erscheinen als eigene Zeilen im Bericht.",
  "tripDetail.invoiceNeedsReview": "Prüfen",
  "tripDetail.invoiceFailed": "Fehler",

  // Expense Scan
  "tripModal.expenses": "Ausgaben",
  "tripModal.expensesHintBefore": "Mit",
  "tripModal.expensesHintAfter": "kannst du ein Foto des Belegs anhängen; den Betrag gibst du manuell in EUR ein. Ausländische Belege (CZK/HUF): Betrag bereits in EUR umgerechnet eingeben.",
  "expenseScan.title": "Beleg anhängen",
  "expenseScan.scanReceipt": "Beleg anhängen",
  "expenseScan.typeToll": "Maut",
  "expenseScan.typeParking": "Parken",
  "expenseScan.typeFuel": "Kraftstoff",
  "expenseScan.typeOther": "Sonstige Kosten",
  "expenseScan.processing": "Beleg wird gespeichert...",
  "expenseScan.error": "Fehler beim Extrahieren",
  "expenseScan.dataExtracted": "Daten extrahiert",
  "expenseScan.amount": "Betrag",
  "expenseScan.quantity": "Menge",
  "expenseScan.pricePerUnit": "Preis/Einheit",
  "expenseScan.vendor": "Anbieter",
  "expenseScan.date": "Datum",
  "expenseScan.cancel": "Abbrechen",
  "expenseScan.extract": "Daten extrahieren",
  "expenseScan.attach": "Beleg anhängen",
  "expenseScan.receiptAttached": "Beleg angehängt",
  "expenseScan.retry": "Wiederholen",
  "expenseScan.useData": "Daten verwenden",
  "expenseScan.invalidFileType": "Nur Bilder erlaubt (JPG, PNG, WebP)",
  "expenseScan.fileTooLarge": "Bild zu groß (max. 10MB)",
  "expenseScan.extracted": "Daten erfolgreich extrahiert",
  "expenseScan.canEditAfter": "Nach Bestätigung bearbeitbar",
  "expenseScan.rotateImage": "Bild drehen",
  "expenseScan.noDataExtracted": "Betrag nicht erkannt. Bitte prüfen Sie, ob der Beleg lesbar ist.",
  "expenseScan.uploadError": "Fehler beim Hochladen",
  "expenseScan.dragDropText": "Bild hier ablegen",
  "expenseScan.clickToUpload": "oder klicken zum Auswählen",
  "expenseScan.useCamera": "Kamera nutzen",
  "expenseScan.uploadFile": "Datei hochladen",
  "expenseScan.errorNotAuthenticated": "Sitzung abgelaufen. Bitte erneut anmelden.",
  "expenseScan.errorQuotaExceeded": "Monatliches KI-Extraktionslimit erreicht.",
  "expenseScan.errorFileNotFound": "Datei nicht gefunden. Bitte erneut versuchen.",
  "expenseScan.errorServer": "Serverfehler. Bitte in einigen Minuten erneut versuchen.",
  "expenseScan.viewReceipt": "Beleg anzeigen",
  "expenseScan.viewReceipts": "Belege anzeigen",
  "expenseScan.deleteReceipt": "Beleg löschen",
  "expenseScan.receiptDeleted": "Beleg erfolgreich gelöscht",
  "expenseScan.deleteError": "Fehler beim Löschen des Belegs",
  "expenseScan.uploadedReceipts": "Hochgeladene Belege",
  "expenseScan.receipt": "Beleg",
  "expenseScan.addMoreReceipts": "Sie können weitere Belege hinzufügen",
  "expenseScan.addAnotherReceipt": "Weiteren Beleg hinzufügen",

  // Kilometerstand — nur Pro
  "settings.tabOdometer": "Kilometerstand",
  "odometer.title": "Kilometerstand",
  "odometer.subtitle": "Kilometerstandsablesungen",
  "odometer.addReading": "+ Ablesung hinzufügen",
  "odometer.date": "Datum",
  "odometer.readingKm": "Ablesung (km)",
  "odometer.source": "Quelle",
  "odometer.notes": "Notizen",
  "odometer.photo": "Foto",
  "odometer.totalKm": "Gesamt km im Zeitraum",
  "odometer.workKm": "Dienst km",
  "odometer.privateKm": "Privat km",
  "odometer.workPct": "Dienstliche Nutzung",
  "odometer.proOnly": "Pro-Funktion",
  "odometer.proOnlyBody": "Die Kilometerstands-Verfolgung ist eine Pro-Funktion zur Berechnung des Dienst/Privat-Verhältnisses (Finanzamt).",
  "odometer.upgradeCta": "Pläne ansehen",
  "odometer.sourceItv": "TÜV / HU",
  "odometer.sourceTaller": "Werkstatt / Wartung",
  "odometer.sourceSeguro": "Versicherung",
  "odometer.sourceManual": "Manuelle Eingabe",
  "odometer.extractingAi": "KI liest km aus…",
  "odometer.extractedByAi": "KI",
  "odometer.editedManual": "Manuell",
  "odometer.userEdited": "Korrigiert",
  "odometer.correctionNoteLabel": "Korrekturgrund",
  "odometer.correctionNotePlaceholder": "z.B. KI-Fehler, Wert manuell korrigiert",
  "odometer.editKmLabel": "Km-Wert bearbeiten",
  "odometer.toastCorrected": "Wert aktualisiert",
  "odometer.userModifiedTag": "manuell korrigiert",
  "odometer.extractionFailed": "KI fehlgeschlagen — manuell eingeben",
  "odometer.deleteConfirm": "Diese Kilometerstand-Ablesung löschen?",
  "odometer.noSnapshots": "Noch keine Ablesungen. Lade dein erstes Kilometerstands-Foto hoch.",
  "odometer.oneSnapshot": "✓ Erste Ablesung gespeichert. Füge eine zweite hinzu, um das Verhältnis zu sehen.",
  "odometer.calcTitle": "Tacho — km Aufschlüsselung",
  "odometer.yearLabel": "Jahr",
  "odometer.toastAdded": "Ablesung hinzugefügt",
  "odometer.toastDeleted": "Ablesung gelöscht",
  "odometer.toastSaveError": "Fehler beim Speichern der Ablesung",
  "odometer.toastExtractError": "KI-Extraktion fehlgeschlagen. km manuell eingeben.",
  "odometer.thumbnailAlt": "Kilometerstands-Foto",
  "odometer.dialogTitle": "Kilometerstand-Ablesung hinzufügen",
  "odometer.dialogSave": "Ablesung speichern",
  "odometer.pctLabel": "{pct}% dienstliche Nutzung",
  "odometer.qrButton": "Handykamera verwenden",
  "odometer.qrTitle": "Mit Handy scannen",
  "odometer.qrBody": "Öffne die Handykamera und scanne den QR-Code, um den Kilometerstand direkt mit dem Handy zu fotografieren.",
  "odometer.qrWaiting": "Warte auf Foto vom Handy…",
  "odometer.qrSuccess": "Foto empfangen! KI verarbeitet…",
  "odometer.qrExpiredModal": "QR-Code abgelaufen. Schließe und versuche es erneut.",
  "odometer.captureTitle": "Kilometerstand-Foto",
  "odometer.captureInstructions": "Richte die Kamera auf den Kilometerzähler im Armaturenbrett und stelle sicher, dass die Zahlen klar lesbar sind.",
  "odometer.captureTakePhoto": "Foto mit Kamera aufnehmen",
  "odometer.captureSubmit": "Foto senden",
  "odometer.captureSuccess": "✓ Foto gesendet! Du kannst dieses Fenster schließen.",
  "odometer.captureError": "Fehler beim Senden. Bitte erneut versuchen.",
  "odometer.captureExpired": "Dieser Link ist abgelaufen. Generiere einen neuen QR-Code vom Computer.",
  "odometer.captureLoading": "Vorbereitung…",
  "odometer.captureOr": "Oder aus Galerie wählen",
};
